var _linearGradient, _linearGradient2, _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewBookSimulator = function SvgNewBookSimulator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3",
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.84999985
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient3",
    id: "linearGradient4",
    x1: 42.362,
    x2: 72.266,
    y1: 91.935,
    y2: 91.935,
    gradientTransform: "matrix(1.29502 0 0 2.00136 27.808 -90.682)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient5",
    id: "linearGradient6",
    x1: 86.019,
    x2: 96.069,
    y1: 113.078,
    y2: 112.952,
    gradientTransform: "matrix(-1.02728 0 0 1.65266 169.289 -95.967)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop5",
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5",
    width: 2.487,
    height: 1.095,
    x: -0.743,
    y: -0.048,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur5",
    result: "blur",
    stdDeviation: "2 2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5-8",
    width: 2.487,
    height: 1.095,
    x: -0.743,
    y: -0.048,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur5-6",
    result: "blur",
    stdDeviation: "2 2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5-8-0",
    width: 2.487,
    height: 1.095,
    x: -0.743,
    y: -0.048,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur5-6-2",
    result: "blur",
    stdDeviation: "2 2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "rightPageLayer",
    className: "show",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "innerRightPage",
    d: "M273.701 165.602c-46.663-.985-84.528-2.777-92.095-4.359-7.596-1.588-12.39-3.085-16.568-5.176l-1.822-.91V29.281l1.822-.912c4.69-2.346 12.477-4.599 19.512-5.644 13.352-1.985 67.919-3.716 128.09-4.065l47.263-.274v147.53l-40.5-.102c-22.274-.056-42.84-.152-45.702-.213m85.161-73.46v-72.38l-44.488.307c-24.47.17-50.967.513-58.885.765-39.157 1.244-55.855 1.993-67.977 3.05-6.138.536-15.714 2.958-20.277 5.13l-2.631 1.251v123.908l2.63 1.252c5.792 2.755 14.473 4.655 25.578 5.596 11.693.99 45.31 2.234 86.092 3.185 2.671.062 21.755.158 42.408.215l37.55.102z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightPage",
    d: "M243.715 170.863c-66.596-1.054-120.637-2.97-131.436-4.662-10.842-1.699-17.684-3.3-23.647-5.536l-2.6-.974V25.063l2.6-.974c6.693-2.51 17.807-4.919 27.848-6.037 19.056-2.123 96.933-3.975 182.808-4.348l67.454-.292V171.2l-57.8-.11c-31.79-.06-61.142-.162-65.227-.227zm121.542-78.568V14.883l-63.494.328c-34.922.18-72.74.548-84.04.817-55.884 1.331-79.715 2.132-97.017 3.263-8.759.572-22.425 3.163-28.938 5.486l-3.755 1.339v132.522l3.755 1.34c8.265 2.947 20.655 4.978 36.504 5.985 16.687 1.06 64.666 2.39 122.87 3.406 3.812.066 31.047.17 60.523.23l53.592.109z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#f7f9f3",
      strokeWidth: 10.6998,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1-7",
    d: "M112.87 170.809c.71.34-24.588-5.103-27.52-5.52l-2.165-.31V21.63l1.799-1.038c4.731-2.73 12.285-5.24 19.273-6.409 3.013-.503 14.02-1.631 15.92-1.631h.698v158.833l-1.874.17c-1.366-.041 9.417 6.717 7.537 5.815z",
    style: {
      fill: "url(#linearGradient4)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.997713,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-0",
    d: "M244.612 176.197c-69.018-1.126-125.023-3.172-136.215-4.979-11.236-1.813-18.327-3.523-24.506-5.91l-2.694-1.041V20.507l2.694-1.04c6.936-2.68 18.454-5.253 28.86-6.447 19.749-2.266 100.457-4.244 189.453-4.642l69.907-.313v168.492l-59.901-.117c-32.946-.064-63.365-.174-67.598-.243zM370.572 92.3V9.636l-65.802.35c-36.192.193-75.384.586-87.095.873-57.916 1.421-82.614 2.277-100.544 3.485-9.077.61-23.24 3.377-29.99 5.857l-3.892 1.43v141.512l3.891 1.43c8.566 3.147 21.406 5.317 37.831 6.391 17.295 1.132 67.018 2.552 127.337 3.638 3.95.071 32.176.181 62.724.245l55.54.116z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "holdingThumb",
    className: "show",
    transform: "matrix(1 0 0 1 -29.103 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M138.668 107.347c-.012-.448.018.102.979-10.085.18-1.908.364-3.832.409-4.275.08-.784.121-1.386.32-4.599.052-.843.205-3.142.338-5.109.134-1.966.233-3.854.22-4.195-.014-.34.018-.946.07-1.345.226-1.716.396-15.908.2-16.78-.049-.222-.13-1.126-.178-2.008a44 44 0 0 0-.164-2.178 44 44 0 0 1-.16-1.69c-.048-.614-.157-1.201-.244-1.306s-.127-.22-.09-.258c.038-.037-.003-.575-.09-1.195-.228-1.594-.328-2.049-.72-3.257a13 13 0 0 1-.294-1.049l-.226-1.135c-.082-.421-.238-.871-.346-1.001s-.149-.385-.09-.567l.104-.33h-.272c-.19 0-.247-.095-.189-.317.046-.174-.016-.4-.138-.5-.121-.101-.266-.425-.322-.72-.123-.659-.803-2.032-.938-1.896-.055.054-.101-.077-.104-.291-.006-.44-.34-.955-.618-.955l-1.687-2.492c-.105-.104-.498-.33-.872-.502-.375-.173-.684-.409-.686-.525s-.076-.167-.164-.113c-.09.056-.12-.006-.068-.14.054-.14-.045-.31-.244-.417-.184-.098-.335-.286-.335-.417 0-.13-.145-.362-.323-.514-.177-.152-.323-.38-.323-.509 0-.246-.923-1.148-1.176-1.148-.082 0-.7-.544-1.372-1.21s-1.274-1.21-1.338-1.21c-.063 0-.192-.218-.284-.484-.108-.31-.28-.484-.477-.484-.169 0-.518-.198-.775-.44a6 6 0 0 0-1.018-.741c-.303-.165-.934-.583-1.401-.929-.85-.627-1.788-1.106-3.455-1.764-.487-.191-.98-.426-1.094-.522-.116-.096-1.205-.23-2.421-.3a94 94 0 0 1-3.663-.279c-2.99-.317-7.943-.131-9.328.35-.372.13-1.003.33-1.402.446-1.916.557-6.103 3.085-6.765 4.085-.14.21-.732 1.062-1.317 1.892-2.55 3.617-3.438 11.08-2.09 17.564.175.843.393 2.14.483 2.881l.165 1.348-.662 1.96c-.365 1.077-.745 2.068-.845 2.201-.244.323-.522.815-1.28 2.259-.348.665-.88 1.547-1.18 1.959a11.5 11.5 0 0 0-.962 1.654c-.228.498-.477.905-.553.905s-.187.163-.246.363-.499 1.143-.979 2.096-.872 1.824-.873 1.936-.613 1.42-1.36 2.906-1.323 2.702-1.28 2.702c.045 0-.06.2-.231.444a3.6 3.6 0 0 0-.434.847c-.067.222-.303.803-.526 1.291-.471 1.034-.507 1.12-1.175 2.824-.278.71-.645 1.554-.815 1.877s-.31.704-.31.847-.062.26-.14.26c-.158 0-1.213 2.689-1.392 3.55-.065.31-.174.638-.242.726-.068.09-.315.695-.548 1.346a59 59 0 0 1-.73 1.936c-.17.414-.5 1.297-.736 1.962a43 43 0 0 1-.736 1.936c-.17.4-.421 1.198-.56 1.775-.138.577-.313 1.194-.39 1.372-1.11 2.59-2.591 7.047-3.887 11.698-.556 1.996-1.391 3.863-2.024 4.526-.216.227-.393.488-.393.58 0 .093-.145.3-.322.46l-.323.292v-.252c0-.138.26-.563.578-.943.948-1.135 1.517-2.476 2.352-5.547 1.014-3.728 1.567-5.438 3.393-10.492.352-.976.776-2.23.94-2.788.165-.557.519-1.573.785-2.258.267-.686.601-1.631.743-2.102.14-.47.428-1.233.638-1.694s.49-1.212.625-1.667c.42-1.426 1.576-4.473 1.894-4.99.375-.611 1.202-2.544 1.687-3.943.2-.577.585-1.485.855-2.017.27-.533.543-1.186.606-1.452.064-.266.176-.562.25-.658.326-.416 3.37-6.59 3.37-6.834 0-.304 2.616-5.082 3.054-5.578.157-.177.53-.756.827-1.286.298-.53.708-1.257.912-1.614.915-1.6 1.522-3.01 1.842-4.277l.345-1.369-.1-1.213c-.054-.667-.244-1.902-.421-2.745-1.39-6.606-.534-14.086 2.01-17.587.549-.755 1.157-1.605 1.353-1.89 2.658-3.866 10.099-5.842 18.737-4.974 7.411-2.143 20.338 15.106 24.055 15.12.052-.005.094.21.094.48 0 .269.067.537.148.596.226.164.551.799.551 1.078 0 .137.097.286.215.332.119.045.223.17.232.277.058.662.427 1.675.776 2.133.226.296.338.576.252.63-.086.052-.125.258-.089.458.037.199.112.652.167 1.007.054.355.15.718.214.807.1.14.178.748.225 1.735.008.155.07.282.14.282s.127.14.127.31.076.334.168.365.2.6.239 1.263c.039.665.113 1.499.165 1.854.14.959.268 2.306.315 3.307.023.489.054.924.068.969.09.277.111 1.774.026 1.774-.131 0-.092.637.061 1 .064.151.091.75.061 1.332s-.002 1.057.063 1.057c.064 0 .054.166-.024.37-.14.371-.233 3.132-.182 5.492.016.77-.048 1.352-.164 1.492l-.19.229.2.484.202.485-.201.241c-.139.168-.145.242-.02.242.1 0 .181.077.181.171s-.083.12-.184.057c-.13-.08-.154.013-.081.313.18.743.27 1.322.172 1.113-.238-.506-.32-.083-.258 1.332.043.974.003 1.611-.11 1.747-.121.146-.129.384-.024.748.084.295.11.604.059.689-.087.14-.296 3.497-.46 7.384-.037.843-.114 1.86-.172 2.259s-.127 1.208-.153 1.797c-.026.59-.095 1.225-.155 1.412-.063.201-.037.34.065.34.094 0 .172.11.172.242 0 .134-.081.242-.18.242-.123 0-.15.283-.084.88.052.484.036.918-.038.963-.073.045-.182.793-.241 1.661-.06.868-.136 1.724-.168 1.902-.135.732-.29 3.013-.313 4.618-.016 1.073-.086 1.69-.187 1.651-.254-.097-.05 3.008-.224 3.008zm-16.441-6.364c0-.084.072-.197.16-.252a.37.37 0 0 0 .157-.292c-.003-.109-.094-.074-.212.08-.154.204-.832.31-.832.13 0-.17-.945-.03-1.055.157-.093.16-.147.176-.15.046-.003-.11-.114-.201-.247-.201s-.242-.092-.242-.204c0-.293-.665-.674-1.089-.624l-.363.044.005-.294c.003-.162.112-.435.242-.607.378-.499.29-.701-.287-.664-.618.039-.958-.055-.847-.233.043-.07-.03-.17-.163-.22-.132-.05-.24-.24-.24-.42V97.1h-.393c-.465 0-.86-.357-.996-.899-.055-.215-.197-.392-.317-.392s-.36-.153-.535-.34c-.174-.187-.398-.29-.497-.228-.1.062-.287.024-.416-.083l-.235-.195v.342c0 .189-.073.343-.161.343-.09 0-.162-.176-.162-.39v-.391l.525-.117.524-.116-.322-.114c-.177-.063-.33-.216-.338-.34-.055-.747-.072-.779-.348-.675l-.283.106.22-.27c.121-.15.303-.225.404-.169.107.06.1.013-.019-.114-.302-.326-.244-.502.147-.446.191.028.379-.04.416-.15.044-.128-.085-.203-.348-.203h-.416v-.402c0-.242-.207-.599-.52-.897l-.518-.496-.193.264-.194.264-.076-.294-.076-.294-.018.363c-.01.2-.084.363-.162.363-.08 0-.134-.127-.121-.282l.022-.283-.363.039c-.2.021-.363-.035-.363-.125s-.183-.233-.407-.318l-.406-.155.205-.332.205-.331.051.329c.028.18.115.329.192.329.24 0 .357-.327.193-.532-.087-.107-.23-.542-.319-.966l-.161-.771.304.096c.331.105.404-.163.152-.562a.52.52 0 0 1 0-.508l.147-.275-.32.083c-.196.051-.32.004-.32-.123 0-.114-.042-.165-.094-.114-.051.052-.009.252.094.445.247.462.08.606-.303.26l-.304-.276-.244.244-.244.244-.083-.317a.43.43 0 0 0-.4-.317h-.318l-.103-.514c-.067-.336-.032-.558.101-.642l.204-.13-.202-.002c-.11-.002-.202-.188-.202-.415 0-.234.07-.37.162-.313.088.055.161.018.161-.082 0-.109.13-.14.323-.08q.324.103.42-.149c.054-.139.174-.205.267-.147.099.06.121.027.054-.082a.42.42 0 0 0-.317-.186c-.292 0-.933-.637-.822-.817.052-.083-.023-.151-.167-.151s-.22-.067-.17-.148.018-.172-.071-.202c-.09-.03-.18-.344-.203-.7l-.04-.645.363-.051c.351-.05.53-.513.198-.513-.094 0-.121-.171-.063-.404l.102-.403-.3-.004c-.192-.002-.097-.102.265-.277.31-.15.588-.33.618-.4s.157-.126.282-.126c.135 0 .229-.162.229-.394 0-.217.073-.439.161-.494.09-.054.162.02.162.166 0 .4.382.19.558-.308l.155-.438-.209-.334c-.134-.215-.153-.39-.052-.49.101-.101.195-.094.265.019.141.228.574.227.574-.002 0-.097-.14-.213-.309-.257l-.308-.081.263-.308c.145-.169.354-.307.464-.307s.279-.146.374-.323l.172-.323-.368-.019a3 3 0 0 0-.53.014c-.09.018-.11-.02-.046-.084.064-.063.381-.14.705-.168l.589-.053-.093.461-.092.461.356.096c.195.052.5.094.678.092l.323-.003-.323-.255c-.223-.177-.26-.279-.12-.331.11-.042.2-.245.2-.453 0-.207-.09-.413-.2-.46-.123-.05-.06-.126.16-.193.477-.145.46-.43-.041-.662l-.402-.187-.017.187c-.009.102-.08-.068-.157-.379-.256-1.027.018-1.59.715-1.465.076.013.272-.018.436-.07l.299-.095-.174-.382c-.108-.237-.264-.348-.41-.292l-.235.09.192.12c.125.076.135.153.027.22-.193.12-.329-.197-.237-.553l.065-.248.595.066c.327.036.683.136.79.222.25.201.531.026.531-.331 0-.196.127-.277.428-.273.235.004.462-.092.503-.212l.075-.219-.34.108-.341.108.097-.252c.053-.14.232-.253.397-.253.195 0 .27-.081.211-.232-.049-.127-.184-.195-.3-.15-.21.08-.227-.013-.25-1.272-.005-.244-.079-.443-.164-.443s-.155-.08-.155-.179.106-.138.235-.089c.283.109 1.03-.457.846-.642-.072-.071-.19-.032-.265.088-.074.12-.22.164-.326.1l-.191-.12.321-.298c.323-.301.316-.958-.01-.958-.088 0-.118.11-.067.242.123.32-.124.31-.396-.017l-.215-.26.307-.224c.169-.124.22-.225.115-.225-.106 0-.192-.072-.192-.161 0-.268.456-.181.632.12.154.264.183.253.235-.091.033-.218.585-.712.585-.525 0 .095.114.173.253.173h.253l-.113-.363c-.062-.2-.18-.389-.263-.42-.082-.031-.047-.177.079-.323s.306-.582.4-.97l.173-.705-.187-.787c-.199-.835-.326-.953-.566-.524-.09.16-.228.215-.351.14l-.204-.126.263-.147c.33-.185.346-.777.02-.777-.132 0-.241-.072-.241-.161s.109-.161.242-.161c.15 0 .242-.153.242-.404 0-.222.055-.403.123-.403s.195-.164.282-.363c.088-.2.25-.372.361-.383s.275-.03.363-.04c.255-.033.188-.344-.097-.453a.37.37 0 0 0-.415.126l-.158.225-.081-.201c-.045-.111-.258-.202-.472-.202h-.39v-.648l-.31.194-.312.194-.395-.18c-.266-.121-.449-.127-.559-.018q-.163.165-.27-.012c-.165-.265.047-.498.452-.498.199 0 .436-.075.527-.166.114-.114.315-.089.638.08.832.434 1.976-.031 1.999-.814.006-.202.931-.105 1.065.112.14.226.392.166.392-.094 0-.145.094-.201.242-.145.256.099 1.21-.795 1.21-1.132 0-.28.612-.766.685-.545.035.103.186.132.35.07.184-.071.253-.207.19-.372l-.1-.26.406.078c.256.05.405.004.405-.122 0-.11.11-.29.242-.401.133-.11.242-.321.242-.469 0-.287.863-.722 1.333-.67.164.017.347-.127.433-.343.09-.226.154-.274.16-.122l.01.252.606-.01.605-.01.056.404c.031.221.14.456.242.521.116.074.064.124-.137.132l-.323.012.35.141.351.142-.087.332c-.047.183-.148.333-.224.333s-.098.127-.049.282l.089.283-.233-.283c-.315-.383-.634-.357-.571.047.028.18.116.32.195.309.151-.021.415.32.419.542.002.072-.161.108-.36.08l-.364-.05-.051.363c-.051.359.125.477.36.242a.5.5 0 0 1 .308-.121c.103 0 .233-.218.29-.484l.104-.484.019.434c.01.239-.054.48-.142.534-.09.055-.162.35-.162.655v.555h-.323c-.22 0-.322.108-.322.34q0 .341-.23.252-.505-.195-.68 1.078c-.092.675-.206.827-.578.771-.064-.01-.043.175.046.41.11.292.11.482-.004.596-.214.214-.218.748-.006.748.089 0 .163-.127.164-.282l.003-.282.156.242c.227.35.2.45-.153.562-.173.055-.278.195-.233.312.045.118-.036.259-.18.314-.164.063-.212.175-.13.303.215.331.159 1.574-.07 1.574-.24 0-.27.423-.04.565.291.18.168.427-.162.323l-.322-.103v.498l.476-.095q.478-.096.726.153c.324.324.315.38-.073.48-.374.098-.441.6-.08.6.132 0 .241-.065.241-.143 0-.26.62-.317.717-.065.054.14.199.2.347.143.152-.058.23-.023.192.088-.034.102-.348.215-.699.25-.35.037-.71.146-.799.243-.113.124-.079.147.116.079.153-.054.32-.028.373.057s-.057.154-.242.154h-.338l.036.53c.02.292-.02.622-.09.734-.068.111-.043.301.058.422.1.12.244.437.32.704l.14.485-.295.077c-.187.05-.268.006-.22-.119.04-.107-.01-.408-.112-.667s-.22-.385-.26-.279c-.039.106-.002.324.083.484l.155.291-.23.214-.23.213-.463-.496c-.524-.56-.707-.624-.62-.213.035.167-.109.397-.352.564l-.41.281.282.002c.254.002.356.18.302.526-.01.066.05.12.137.12.086 0 .117.103.069.228-.052.135.042.269.232.329.347.11.36.48.046 1.27-.223.56-.228.755-.02.755.09 0 .162-.152.162-.338s.127-.567.282-.847.296-.534.312-.566c.016-.03.117-.003.223.063l.192.12-.263.147-.263.147.021.958c.013.585-.06 1.058-.19 1.214l-.213.256.232.148c.127.08.322.114.433.073.111-.04.202-.005.202.08s-.335.118-.767.073l-.766-.079.432.173.433.172-.03.428c-.02.293.061.446.254.486.155.032.282-.023.282-.124 0-.1-.072-.138-.16-.083-.09.055-.162.023-.162-.071s.109-.17.242-.17.242.076.242.17.066.13.146.08.108.055.062.233-.011.323.078.323c.09 0 .206-.174.26-.386.053-.212.214-.43.358-.486l.261-.1-.094.244c-.05.134-.018.244.073.244.09 0 .12.072.066.161-.094.153.106.225.498.18.096-.011.258.161.36.384.1.222.258.404.348.404.091 0 .165.073.165.162 0 .088-.1.161-.224.161-.128 0-.27.241-.33.565-.059.313-.202.564-.323.564-.12 0-.259.108-.31.24l-.091.238.339-.037c.186-.02.371.053.41.164.042.118-.061.202-.247.202-.175 0-.36.109-.412.242-.05.133-.03.242.047.242.166 0 .118 1.312-.059 1.597-.18.292.042.435.363.235.398-.249.986.009.955.418-.014.183-.114.332-.223.332-.118 0-.219.277-.248.685l-.05.686-.453.052c-.261.03-.426.133-.389.242.036.105.232.166.435.136.204-.03.415.015.47.1.054.084.252.2.44.26l.341.106-.018-.529c-.01-.29.05-.547.136-.57.085-.023.17.283.188.68l.033.72-.296.094c-.162.052-.493.044-.736-.017l-.441-.11.116.187c.063.103.173.152.242.11.07-.044.21.103.312.326.113.25.294.387.467.358l.282-.047.006.587c.003.323.103.704.222.847q.213.259.035.26c-.1 0-.181.145-.181.323 0 .177-.073.322-.162.322s-.161-.109-.161-.242a.243.243 0 0 0-.242-.242c-.336 0-.303.178.12.647.449.496.505.965.15 1.235l-.27.206.282.005c.156.003.283.071.283.153 0 .081.044.263.097.403.063.163.01.255-.142.255-.132 0-.276-.136-.32-.304l-.08-.304-.411.079c-.253.048-.381.16-.332.288.044.115.003.257-.092.315-.212.131-.227.41-.023.41.083 0 .277-.126.431-.28.172-.172.304-.213.34-.105.032.098.238.143.457.101.218-.042.396-.013.393.064-.005.173-1.107.735-1.258.642-.06-.037-.12.11-.133.325l-.023.393.422-.422c.272-.272.446-.352.488-.225.036.109-.054.264-.2.346s-.222.221-.168.309c.062.1.181.09.326-.03.125-.104.228-.128.228-.054s-.2.3-.444.503l-.444.369.26.157c.172.104.235.299.184.566-.098.513-.573.539-.812.044l-.175-.363-.01.282c-.007.172-.138.283-.334.283-.178 0-.323.086-.323.192s-.096.06-.214-.101l-.215-.293-.362.193-.362.194-.087-.33-.086-.332-.307.165-.308.164-.089-.232a1.14 1.14 0 0 1-.038-.515c.028-.155-.035-.312-.14-.349-.356-.125-.183.892.216 1.267.215.202.379.27.379.157 0-.11.072-.154.161-.1.31.192.18.608-.161.518-.177-.046-.363-.018-.413.062s.037.146.192.146h.282l-.313.243-.313.242.395.333.394.334-.453-.114-.453-.114.279.426c.3.458.427.54.362.233-.022-.105.087-.22.243-.254.155-.034.282.016.282.112 0 .095-.066.173-.146.173-.25 0 .003.624.283.7l.266.073-.363.116c-.2.064-.363.222-.363.35q-.002.239.313.135l.314-.099-.031.678-.031.678-.394.06c-.537.08-.623.204-.306.435.428.314.409.648-.067 1.124-.244.244-.443.368-.443.275s-.11-.169-.242-.169a.243.243 0 0 0-.242.242c0 .134-.073.242-.162.242-.088 0-.161.182-.161.404 0 .25-.091.403-.242.403-.133 0-.242-.068-.242-.152zm-18.233-15.697c0-.143.073-.284.163-.314s.194-.215.232-.411c.077-.401-.454-1.169-.663-.96-.074.074-.01.226.145.339.311.227.217.44-.135.305-.124-.047-.234-.242-.243-.432-.01-.224-.086-.121-.213.289l-.197.635-.104-.272c-.058-.152-.278-.272-.495-.272s-.431-.103-.48-.23c-.054-.14-.217-.195-.42-.142l-.333.087v-.561l-.258.214-.257.213-.15-.268c-.083-.147-.257-.227-.388-.176-.287.11-.313-.127-.044-.395.106-.107.134-.194.06-.194-.072 0-.041-.109.069-.242l.2-.242-.173-.21c-.096-.116-.135-.363-.086-.55l.089-.338-.338-.108c-.186-.058-.337-.174-.337-.257s-.11-.15-.242-.15a.243.243 0 0 0-.242.241c0 .253-.191.32-.377.134-.06-.059-.006-.222.118-.363s.25-.394.282-.564c.086-.463.47-.525.42-.067l-.04.376.453.052c.25.029.558-.034.686-.14l.232-.193v.18c0 .241.53.233.775-.011l.194-.194.193.194c.107.106.36.193.565.193s.371.073.371.161c0 .09.109.162.242.162s.242-.073.242-.162c0-.088-.083-.16-.184-.16s-.275-.125-.386-.277l-.202-.276-.26.215c-.303.252-.353.012-.058-.283l.2-.2-.24-.152c-.133-.084-.165-.153-.072-.155s.263.088.377.2l.207.201-.055-.403-.054-.404-.334.034-.333.033.07-.477c.072-.49.253-.612.446-.3.06.096.284.143.497.102l.388-.074.268.453c.148.25.33.415.407.368s.244.002.372.107c.128.107.345.15.483.098.15-.058.292.011.354.174.057.148.022.297-.078.33-.12.04-.074.237.131.575.173.282.324.731.336.998l.023.484.07-.364.07-.363.23.23c.128.128.232.305.232.395 0 .28.302.366.644.183l.328-.176.105.272c.065.17-.007.354-.195.491-.394.289-.721.278-.721-.023 0-.31-.227-.31-.483-.002-.215.26-.508.177-.47-.132.099-.802-.39-1.024-.973-.441l-.313.313-.072-.273-.072-.272-.019.352a.43.43 0 0 0 .318.459l.336.107-.097.39c-.054.213-.042.38.026.368.458-.074.992.056 1.07.26.115.298-.035.726-.254.726-.089 0-.122-.103-.073-.228.048-.126-.023-.271-.158-.323-.366-.14-.423-.117-.326.136.049.127-.016.317-.144.423s-.232.26-.232.341-.146.305-.323.495l-.323.346zm20.332-44.44c-.22-.112-.583-.17-.806-.127l-.406.078.363-.16c.388-.17.509-.868.184-1.068q-.178-.11-.075.213c.062.197.021.355-.104.403-.36.137-1.255-.069-1.255-.288 0-.322-.858-.441-2.272-.316l-1.278.113v-.244c0-.16.105-.216.304-.164.168.044.354.001.413-.096.061-.098-.006-.175-.152-.175-.15 0-.214-.076-.152-.177l.11-.178-.316.17c-.388.207-.96.076-1.084-.249-.16-.416.084-.572.419-.269l.316.287.137-.222c.077-.124.072-.395-.01-.613l-.149-.39.203.071c.112.04.196.175.187.3a.58.58 0 0 0 .169.403l.185.173.184-.39.185-.392-.233.193-.232.193v-.189c0-.236-.817-.968-1.09-.975-.244-.006-.264.351-.033.583.117.116.102.223-.048.348l-.218.18-.016-.569-.016-.569.348-.14.347-.14-.403-.03c-.282-.02-.319-.05-.121-.102l.282-.074v-.597c0-.677.41-1.378.732-1.254.119.045.252-.004.296-.11.045-.107.074-.048.066.13-.008.177-.004.546.01.82l.025.5.404.183.403.184v-.23c0-.125-.072-.273-.161-.328-.199-.123-.204-.41-.012-.712l.144-.228.255.255c.173.173.195.276.07.318-.103.034.112.058.477.053l.664-.009.091-.363c.057-.223.215-.363.411-.363.176 0 .327-.09.336-.202.01-.11.074-.02.145.202q.13.404.146.12c.018-.318.336-.392.343-.08.003.112.078.076.17-.08.24-.414.714-.345.933.137l.191.42.224-.186c.153-.127.256-.132.328-.016.058.093.29.169.517.169h.412l-.071.484c-.05.338-.004.484.151.484.123 0 .299.218.391.483l.169.484.366-.092.366-.092.116.375c.064.206.104.662.088 1.012l-.028.637.242-.201c.134-.112.282-.136.332-.055.127.205-.026.907-.212.968-.084.029-.111.163-.059.299.058.151-.08.396-.357.635-.523.45-.633.481-.505.147.092-.24-.039-.296-1.062-.453l-.44-.067-.102.32c-.057.18-.016.372.094.44.127.08.138.157.031.223-.09.056-.202.01-.247-.1-.056-.14-.124-.15-.215-.032-.093.12-.255.11-.535-.034zm-13.273-1.777c-.155-.043-.282-.15-.282-.237s-.065-.119-.143-.07c-.079.048-.233-.02-.343-.152s-.305-.24-.435-.24-.209-.08-.176-.18c.074-.221-.711-1.106-.888-.999-.07.043-.034.192.081.332l.21.254-.363-.193c-.2-.107-.363-.26-.363-.34 0-.397-.981-1.19-1.545-1.247-.327-.033-.785-.157-1.018-.274s-.52-.179-.638-.137c-.119.042-.572-.117-1.008-.354-.46-.251-.877-.38-.994-.307-.253.157-1.12.079-1.324-.119-.222-.214-.958-.18-1.197.054l-.206.202-.312-.383-.313-.383-.489.098-.488.098-.09-.236c-.086-.222-1.54-.539-1.915-.418-.089.028-.307.07-.484.093-.178.022-.395.051-.484.064s-.053.094.08.18l.243.156-.3.003q-.3.003-.207.244c.051.134.029.242-.05.242-.078 0-.172-.088-.208-.195l-.065-.196-.553.272-.554.271-.2-.267-.201-.267.43-.282c.237-.155.494-.396.572-.535s.32-.253.537-.253.395-.055.395-.122c0-.847 4.647-.783 7.18.1.533.185 1.086.339 1.229.341s.447.15.674.33c.233.183.456.258.51.17.052-.084.51.122 1.02.46.508.336 1.105.669 1.327.739s.5.264.62.433l.216.308.236-.197c.13-.108.224-.13.209-.048-.069.36.034.538.373.643.2.062.553.246.785.41s.471.246.533.185c.061-.062.162-.041.223.046.23.323 1.31 1.043 1.565 1.043h.263l-.05.444-.052.443-.645.026c-.355.013-.773-.01-.928-.053z",
    style: {
      fill: "#c18d76",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m66.563 165.29.002-32.234.004-12.582c.018-2.818.1-3.366.557-3.74.089-.072-.002-.085-.201-.029l-.363.103v-1.586l.322-.292c.178-.16.323-.367.323-.46 0-.092.177-.353.393-.58.633-.663 1.467-2.53 2.024-4.526 1.296-4.65 2.777-9.107 3.888-11.698.076-.178.251-.795.39-1.372.138-.577.39-1.375.559-1.775s.5-1.27.736-1.936c.235-.665.566-1.548.735-1.962s.498-1.284.73-1.936c.234-.651.48-1.257.549-1.346.068-.088.177-.415.241-.726.18-.861 1.235-3.55 1.393-3.55.077 0 .14-.117.14-.26s.14-.524.31-.847.537-1.167.815-1.877c.668-1.704.704-1.79 1.175-2.824.222-.488.46-1.069.526-1.29.067-.223.262-.604.434-.848s.276-.444.232-.444.53-1.216 1.278-2.702c.748-1.487 1.36-2.794 1.36-2.906.002-.112.394-.983.874-1.936s.92-1.897.979-2.096.17-.363.245-.363c.077 0 .325-.407.553-.905s.66-1.242.962-1.654c.3-.412.833-1.294 1.182-1.96.756-1.443 1.035-1.935 1.279-2.258.1-.133.48-1.124.844-2.201l.663-1.96-.165-1.348a43 43 0 0 0-.483-2.881c-.874-4.203-.787-8.939.245-13.473.397-1.743.766-2.56 1.845-4.09.585-.83 1.178-1.682 1.317-1.893.662-1 4.85-3.528 6.765-4.085.4-.116 1.03-.317 1.402-.446 1.384-.481 6.338-.667 9.328-.35.798.085 2.447.21 3.663.28 1.216.068 2.305.203 2.42.299.116.096.608.33 1.094.522 1.668.658 2.606 1.137 3.455 1.764.468.346 1.099.764 1.402.929s.761.498 1.018.74c.257.243.606.44.775.44.197 0 .368.175.476.485.093.266.221.484.285.484s.666.544 1.338 1.21 1.29 1.21 1.372 1.21c.253 0 1.176.902 1.176 1.148 0 .128.145.357.323.509.177.152.323.383.323.514s.15.319.335.417c.199.107.298.277.244.418-.052.134-.022.195.068.14.088-.055.161-.005.164.112.003.116.31.352.685.525.375.172.768.398.873.502l1.835 1.68c-.35.187-.359.784-.044.784.279 0 .508.544.514.983.003.214.05.345.104.29.135-.135.815 1.238.938 1.897.056.295.2.619.322.72s.184.326.138.5c-.058.222-.002.317.19.317h.27l-.104.33c-.058.182-.017.437.09.567.109.13.264.58.347 1l.226 1.136c.04.204.173.676.294 1.049.392 1.208.492 1.663.719 3.257.088.62.13 1.158.092 1.195s.003.154.089.258.196.692.244 1.306.12 1.374.16 1.69.115 1.295.164 2.178c.049.882.13 1.786.179 2.008.194.872.024 15.064-.201 16.78a10 10 0 0 0-.071 1.345c.014.34-.085 2.229-.219 4.195s-.286 4.266-.338 5.11c-.199 3.212-.24 3.814-.32 4.598-.045.443-.23 2.367-.41 4.275-.559 5.93-.794 8.286-.894 8.955-.054.355-.091.864-.084 1.13s-.059.883-.146 1.371a24 24 0 0 0-.24 2.098l-.395.887c.082-.532.222-1.767.313-2.743.09-.976.198-2.065.24-2.42l.323-2.743c.28-2.37.322-2.85.559-6.454.093-1.42.24-2.945.326-3.388.135-.697.538-5.855.53-6.777-.002-.178.093-1.593.21-3.146.118-1.553.257-3.84.31-5.083.052-1.242.133-2.985.179-3.872.254-4.916.081-13.683-.344-17.437a242 242 0 0 1-.314-2.893 16 16 0 0 0-.237-1.533c-.088-.4-.24-1.198-.337-1.775s-.282-1.36-.408-1.74c-.127-.38-.23-.883-.23-1.117 0-.428-.604-2.155-1.051-3.005-.132-.251-.24-.522-.24-.6 0-.131-.344-.93-1.04-2.412-.56-1.196-.835-1.622-.97-1.5-.077.071-.212.03-.151-.139.074-.205.014-.332-.193-.477-.168-.118-.227-.443-.274-.623l-.086-.328.382-.096-.192-.781a5.3 5.3 0 0 1-1.228.088l-.273.847.266.26.195-.207.257.213c.16.134.194.252.09.316-.092.057-.212.328-.267.603l.242.609c.188.06.3.177.248.26a.18.18 0 0 1-.245.06c-.266 1.07-.168 1.396-.009 1.563.151.157.438.111.54.395.063.172.14.255.233.198.093-.058.056.057-.003.152s-.015.21.096.255l.203.082-.242.171c-.342.242-.49.216-.381-.066.214-.558.111.108-.18.709-.17.355-.493.182-.422.547.045.23-.283.652-.563.81-.126.07-.229.27-.229.443l-.308.506c.473.165.631.535.28.652-.123.04-.14.147-.047.296.08.128.24.416.214.665-.026.248-.078.576.03.705l.193.234h-.2.16l-.035.214c-.036.215.242.221.117.221-.1 0 .09.1.09.23 0 .156-.4.257-.224.19l.27-.104-.111.29c-.062.16.145.286.246.408s.86.09.785.09c-1.312.434.388 1.67-.038 3.04-.329 1.057-.427 1.304-.44 1.109-.02-.289-.225-.202-.225.089 0 .133.033.346-.095.346l-.594.814c-.117 1.027-.468 1.611-.975 1.62l.988-.167c-.055-.088 0-.161.123-.161.157 0 .203.145.152.489-.261.404 1.511.688.47 1.332-.21.13-.122.61.067.494.166-.103.102.347-.044.493-.053.053-.266.137-.463.096-.17-.035.287.323-.136.323h.43l-.093.242c-.058.15.224.242.155.242h.248l-.116.363c.05-.156.847 1.469.533 1.573-.108.036.206.114.206.253v.253l-.236-.083-.57 1.386-.283-.107c.137.006.346.647.328.805.11.371.468 2.336.31 2.481l.115.36.181.219-.259.37c-.177.253-.355.338-.568.27-.169.192.358 1.528.348.812l.317.38c-.08.44.539.113.56.56 0 .276.39.633.39.633l.164-.282.005.506.005.506c-.269.346.31-.033.717-.12.094.003-.232.032-.115.171.246.294-.136 1.639.038 1.567l-.162-.303-.163-.303.24.092 1.025 1.906-1.21 1.06c-.145.127.617.142.508.142l-.797.921c.222.056.403.203.403.326 0 .28-.27.296-.366.023-.04-.111.484-.113.483.13-.004.483-.45.663-.149.362l.194-.194v.355c0 .244-.098.355-.313.355-.173 0 .323.1.269.19-.055.088.638.087.057.272-.4.128-.262.29-.247.284.144-.056.208-.029.152.063-.054.088.121.09-.017.104l.032.215c.367.095-.112 1.131-.305 1.131-.092 0 .263-.002.329.064.065.065-.154.175-.028.176.125.002.23.075.23.164.002.088-.089.161-.2.161-.11 0-.298.091-.416.203s-.459.122-.363.112c.35-.037.63.05.63.187 0 .144-.64.224-.456.224.178 0 .323.073.323.161 0 .09-.085.162-.188.162-.104 0-.14.048-.082.106s.031.196-.06.306c-.252.304-.06.747.095 1.289.083.287-.17.558-.256.558-.151 0-.8 1.302-.8 1.604 0 .513-.38.643-.017 1.502l-.232.232c-.623.559-.872-.837 0 .32.051.135-.282.188-.18.169.103-.02.187.073.187.206 0 .274-.425.339-.596.091-.105-.15.97.658.16.597l.328.024-.026.685-.027.684-.323.095.331.096-.29.255c-.145.127 1.414 1.095.835 1.595-.094.058-.13.217-.077.353l.095.248c-.394-.14 1.093.238-.048.568l-.281.195c.396-.274.669.235.302.357-.1.033-.23.347-.289.699l-.417 1.634.024.777.268.195-.509.226c.31-.138.19.643.33.422l.125-.195.003.255c.004.418-.154.458-.84.216-.35-.504.38.44.798.424.179-.11-1.023.083-1.16.306-.054.086-.195.118-.315.072-.152-.058-.238.092-.285.492-.082.698.097.74.427.1.406-.783.59-.764.537.057-.028.444-.128.748-.249.76-.428.043-.501.064-.615.178-.064.064-.024.229.089.365l.206.248.224-.187c.124-.102.277-.133.342-.07.064.065.005.203-.132.306l-.248.189.259.252c.142.139.344.223.45.188.308-.103.22.285-.09.4-.545.201-.7.693-.22.693h.306l.074.685c.04.378.011.755-.064.84-.21.233-.164.41.105.41.133 0 .242.073.242.162 0 .234-.605.199-.691-.04-.04-.111-.017-.31.05-.444.144-.285-.198-.664-.456-.504-.116.072-.131.309-.044.694.153.679.068.852-.432.878-.254.014-.363-.071-.363-.282 0-.35.056-.363.535-.13l.352.173-.403-.33c-.222-.182-.47-.332-.552-.334s-.282-.124-.445-.271-.35-.21-.416-.14c-.066.071-.03.161.082.201.238.085.274.852.04.852-.089 0-.161.065-.161.144 0 .213.907 1.147 1.113 1.147.259 0 .217.334-.084.667-.376.415-.187.76.37.674l.456-.072-.303.245c-.3.243-.256.86.048.672.083-.051.202.068.265.265.07.218.042.382-.07.419-.232.077-.236.56-.006.79l.175.176-.175.108c-.097.06-.385-.12-.64-.4l-.466-.51-.124.202c-.073.118-.015.281.142.396.348.254.337.346-.056.448-.178.047-.282.019-.232-.062.14-.227-.088-.172-.344.085-.32.319-.29.498.13.776l.361.24-.24.289c-.493.594-1.712.852-1.508.319l.083-.217-.553.044c-.767.061-.961.206-.766.57l.159.298-.22.084c-.135.052-.337-.132-.522-.475-.165-.308-.464-.6-.664-.65-.4-.1-.518-.774-.161-.918l.201-.081-.213-.013c-.243-.015-.674.371-.674.604 0 .184-.414.368-.541.24-.049-.048-.055-.28-.014-.513.042-.239-.03-.56-.167-.734l-.24-.31-.317.286-.316.287-.138-.53c-.16-.615-.526-.832-.526-.31 0 .209-.08.32-.202.278-.11-.039-.181-.184-.157-.324.025-.14-.03-.3-.12-.356-.092-.056-.166-.243-.166-.415v-.313h-.813l.098-.392.099-.393-.338.089-.337.088v-.258c0-.381-.758-.52-1.108-.202-.16.143-.356.259-.438.256-.081-.003-.004-.115.174-.249.192-.145.257-.289.161-.358-.088-.063-.16-.223-.16-.356 0-.141-.118-.222-.283-.195l-.282.048v-.397c0-.219.085-.426.19-.46.248-.084.02-.448-.28-.448-.128 0-.233.145-.233.322 0 .428-.422.416-.535-.016-.049-.186-.16-.295-.247-.24-.087.053-.201.006-.254-.106-.052-.111-.057-.003-.01.241l.084.444h-.255c-.172 0-.24.118-.205.363l.05.363-.363.052c-.37.052-.858.674-.53.674.092 0 .167.063.167.14 0 .076-.127.125-.282.11-.483-.052-.847-.274-.847-.519 0-.128.073-.189.161-.134s.163.005.164-.112l.003-.21.17.241.169.242-.107-.379-.107-.379.325.103c.178.057.371.028.429-.064.057-.093-.018-.168-.166-.168h-.269l.101-.404.102-.403h-.245q-.246-.002-.245.484v.484h-.646v.645c0 .78-.214.839-.444.121l-.168-.524-.017.605c-.009.333-.07.597-.137.586a2.5 2.5 0 0 0-.404 0c-.343.023-.38.342-.04.342.133 0 .242.074.242.165 0 .09.178.048.396-.095.5-.328.71-.203.618.37l-.071.447.171-.242c.12-.169.172-.18.174-.037.002.113-.179.288-.4.39-.223.1-.404.273-.404.382s-.164.24-.363.29c-.497.124-.693.065-.634-.194.08-.344-.272-.05-.526.44l-.229.444-.496-.035c-.272-.019-.495.015-.495.075 0 .203.578.607.774.542.285-.095.242.716-.043.825-.13.05-.28.02-.334-.066-.166-.268-.397.007-.397.473 0 .244-.108.584-.24.757l-.241.313.028-.484c.049-.842-.026-1.372-.193-1.372-.088 0-.16.141-.16.313s-.073.359-.162.413c-.089.055-.162.023-.162-.07 0-.095-.108-.172-.242-.172-.133 0-.242.141-.242.314 0 .172-.077.36-.171.419-.265.163.306.706.67.636.193-.037.308.031.308.183 0 .133-.067.2-.15.15a.18.18 0 0 0-.245.06c-.147.238.222.385.464.184l.216-.179.1.26c.054.142.1.4.1.571v.313l.403-.101.403-.102v.322c0 .192-.138.357-.344.41q-.34.092-.249.337c.052.136.034.285-.041.33-.075.047-.174-.06-.22-.236-.09-.34-.51-.434-.683-.153-.058.093-.017.275.09.404l.196.235h-.28c-.188 0-.247.083-.18.257q.1.257-.234.344c-.197.051-.298.176-.248.307.049.127-.018.221-.157.221a.39.39 0 0 0-.334.24c-.051.133-.375.326-.721.43l-.629.188v.632l.323-.084c.177-.047.322-.023.322.052 0 .076.218.266.485.423.598.354.606.472.04.623-.245.065-.35.152-.234.195l.21.077-.29.226-.291.226.309-.108c.2-.071.27-.048.201.065-.068.11.01.143.216.089.224-.059.323-.005.323.176 0 .171.139.261.403.261.222 0 .403.078.403.172 0 .097-.136.13-.309.075-.17-.054-.354-.026-.409.063-.055.09.127.22.404.293l.503.13-.66.176c-.362.097-.658.113-.658.037s-.118-.139-.262-.139h-.262l.188.227c.107.129.143.406.083.645-.064.257-.038.419.069.419.095 0 .132-.11.08-.242-.058-.155.004-.242.172-.242a.41.41 0 0 0 .358-.242c.095-.25.542-.343.542-.113 0 .07-.09.22-.202.332l-.201.203.282-.107c.275-.105.358.046.293.536-.015.114.122.396.304.627.45.573.419.839-.048.4-.445-.418-.921-.314-.893.196l.018.346.074-.282c.04-.156.133-.283.205-.283.226 0 .324.7.131.932l-.184.222.22.137.222.137-.21.254a.77.77 0 0 1-.515.254q-.304-.001-.303.354v.354l.215-.294.214-.293.344.184c.488.261.284.713-.283.63-.25-.037-.529.039-.658.177l-.225.24.298-.113q.297-.113.509.17l.212.286.24-.323.24-.323.113.29q.112.292-.249.676l-.362.385-.282-.176c-.156-.097-.4-.132-.542-.078l-.258.1.221.525c.246.586.677.87.508.334l-.103-.322.328-.085c.41-.108.416.162.014.685l-.305.398-.402-.215c-.458-.245-.785-.119-.719.279l.045.27-.513.05c-.651.063-.893.359-.95 1.164-.043.6.049.73.466.656.162-.028-.044.692-.218.76-.186.073.213 1.011.403.949.092-.03.189-.206.216-.391.09-.612.461-.538.73.145l.253.646.452-.03c.248-.017.568-.023.711-.013l.26.017-.073.385c-.04.211.01.435.111.498.126.078.17-.028.137-.33l-.05-.445.527-.14c.29-.076.61-.275.714-.44.236-.379.608-.26.498.158l-.08.31.38.154c.21.084.293.157.185.163s-.155.119-.103.252c.058.153-.002.242-.167.242-.288 0-.348.248-.098.403.292.18.169.428-.161.323-.298-.095-.405.045-.342.444.018.113-.616.192-1.07.133-.11-.015-.202.082-.202.215 0 .132-.103.299-.23.37-.127.07-.218.274-.202.452.02.225-.056.308-.253.275-.345-.058-.36.125-.046.54.13.173.24.368.242.435.008.185-.607.144-.726-.048-.072-.118-.167-.117-.311.003-.114.094-.338.122-.497.06-.169-.064-.249-.046-.193.045.057.092-.13.129-.459.09l-.555-.064.084.22c.058.15.337.21.89.189.85-.032 1.089.194.391.37-.256.064-.381.185-.33.32.102.264-.293 1.074-.447.92-.06-.061-.226-.128-.368-.149l-.259-.038.183.183c.23.23.232.928.005 1.247l-.173.242.09-.524c.054-.312.023-.524-.076-.524-.092 0-.119-.079-.06-.174.07-.112-.053-.155-.347-.121-.292.034-.485.169-.541.378a.42.42 0 0 1-.41.32c-.178-.003-.414.06-.525.138-.124.088-.294.066-.443-.057-.167-.14-.242-.145-.242-.02 0 .244-.547.778-.736.718-.429-.135-.858.89-.434 1.035.119.04.202-.07.202-.268 0-.185.077-.336.17-.336s.127.071.074.158-.027.292.06.455l.16.296-.752.039c-.412.021-.838.111-.945.2l-.195.162-.064-.373-.065-.372-.133.3c-.088.197-.041.456.133.751.342.58.337.623-.097.81l-.363.157.565-.091q.563-.09.345.06c-.151.104-.164.184-.042.26l.177.11-.191.205c-.105.112-.359.173-.563.134-.204-.04-.562.053-.795.206s-.377.202-.32.11a.19.19 0 0 0-.056-.265c-.088-.054-.209.098-.269.337l-.109.435.263.193c.29.212.195.402-.202.402-.176 0-.255.15-.255.482v.482l.282-.09c.35-.11.368.193.031.53-.138.138-.216.343-.173.454.05.132-.026.176-.22.126-.185-.049-.36.04-.466.24-.1.187-.337.318-.579.318h-.408l-.002-.343-.002-.343-.149.234c-.081.129-.117.285-.079.346.114.185-.344.288-.589.133-.423-.268-.63-.157-.63.336q0 .483-.243.484a.243.243 0 0 0-.242.242c0 .133-.072.242-.16.242-.09 0-.162.173-.162.384 0 .41.498.667.767.397.26-.26.586.336.687 1.252l.095.87-.307.097-.307.097.178.178c.273.273.217.602-.083.487l-.26-.1.11.347c.061.195.04.347-.05.347-.088 0-.208-.223-.268-.495s-.21-.534-.336-.582c-.124-.048-.226-.188-.226-.312 0-.123-.146-.224-.323-.224s-.323.077-.323.172c0 .096-.109.282-.242.415l-.242.242v-.829h-.473c-.309 0-.505.098-.564.282-.05.155-.308.428-.575.605-.266.178-.485.413-.485.524s-.073.202-.162.202c-.088 0-.161-.213-.161-.474s-.074-.52-.164-.576a.196.196 0 0 1-.06-.27c.096-.155-.194-.447-.45-.452-.26-.006-.212.592.074.913.325.367.261.698-.136.698-.127 0-.232.072-.232.161s.117.161.26.161q.256.002.16.256c-.053.14-.097.33-.097.42 0 .091-.11.124-.242.073-.133-.051-.242-.03-.242.046 0 .184.473.36.66.245.08-.05.146.018.146.15s.164.263.363.292l.363.051-.042.404c-.023.221-.053.494-.067.605s-.11.201-.215.201c-.545 0-1.064 1.445-.685 1.906l.203.246-.616-.1-.615-.098.05.258c.054.272.56.43.692.216.105-.17.944-.003 1.091.218.207.31.133.743-.128.743-.138 0-.204.076-.147.168s.033.256-.054.363-.312.471-.5.809l-.343.614.245.245.244.244.025-.294a5 5 0 0 0 .02-.483c-.002-.104.095-.15.217-.103.122.046.222.18.222.294 0 .132.123.178.33.124.18-.047.295-.12.255-.16-.129-.128.479-.637.882-.739l.389-.098-.363.3c-.572.472-.38.813.457.813.44 0 .38.208-.128.444-.576.268-.854.255-.854-.04a.243.243 0 0 0-.242-.242.243.243 0 0 0-.242.242c0 .139-.145.242-.342.242h-.343l.217.261.218.262-.843-.073-.843-.073v.215c0 .183-.425.3-.847.234-.067-.01-.121.09-.121.223s.08.242.179.242.137.106.087.236-.03.274.042.32c.232.143-.166 1.5-.434 1.48-.134-.011-.276.076-.318.193-.04.117.024.196.144.176.343-.057.784.188.784.435 0 .276-.35.294-.613.032l-.194-.194v.841l-.348-.091-.348-.091.09.348c.05.191.026.389-.054.438-.08.05-.147.2-.147.333s.076.195.169.138c.092-.058.287-.007.431.111l.263.216-.1-.404-.1-.403.294.356c.162.196.336.314.387.263s.081.202.067.562l-.026.655-.277.072c-.189.05-.262.206-.23.494.056.511-.167.559-.322.069l-.112-.353-.198.27c-.108.148-.244.222-.302.164s-.105.022-.105.177c0 .307-.39.27-.424-.04-.01-.103-.029-.26-.04-.35a.19.19 0 0 0-.18-.16c-.087 0-.142.154-.12.342l.038.343-.363.06c-.2.032-.363-.018-.363-.11 0-.094.072-.126.161-.071.2.124.213-.122.018-.33-.08-.085-.11-.379-.067-.653l.078-.5.389.075.388.074-.044-.543c-.04-.484-.327-.713-.379-.301l-.04.322c-.011.09-.165.162-.343.162-.177 0-.322.08-.322.178 0 .099-.11.137-.242.086l-.242-.093v.797h-.684l.085.325q.085.323-.227.492c-.172.092-.264.247-.203.345.068.11.23.012.43-.263l.321-.441.132.213.132.213.208-.224.209-.224-.202.114c-.122.07-.202.019-.202-.128 0-.47.298-.418.406.071.063.286.257.56.457.646l.348.149-.484-.039c-.267-.021-.538-.11-.603-.2-.067-.092-.12-.04-.121.12-.001.174-.126.283-.325.283h-.323v.968h-.323c-.22 0-.322.108-.322.34v.34l-.251-.096-.251-.097-.243.582c-.134.32-.206.68-.16.8s.017.26-.063.31c-.081.05-.103.207-.048.35l.1.262-.439-.084-.439-.084.083.216c.046.119.022.254-.053.3s-.176-.067-.224-.253c-.053-.203-.162-.291-.274-.222-.103.063-.15.258-.104.433l.083.317-.23-.089c-.127-.048-.23-.018-.23.068s-.146.157-.323.157c-.198 0-.325.109-.328.282-.011.632-.721 1.112-1.094.739-.278-.278-.573-.277-.465.003l.083.217-2.595.03-2.595.03-.13-.207-.132-.207-.003.202-.003.202H66.562zm5.506-44.008c.43-.42.684-1.426.3-1.189-.088.055-.16.023-.16-.07 0-.095.108-.172.241-.172.153 0 .242.154.242.417 0 .506.38.45.455-.066.068-.462.316-.446.534.035.097.212.35.465.562.561s.385.274.385.395v.218h1c.618 0 1.023.072 1.062.188.092.276.93.23 1.174-.064l.21-.252.14.252c.169.302.713.336.818.05l.074-.2.19.177c.236.222 1.016.09.93-.158-.035-.1-.238-.172-.45-.162-.214.01-.444-.076-.512-.194-.122-.208-.574-.204-1.84.015-.287.05-.558.013-.618-.084-.06-.095-.246-.129-.416-.075-.215.069-.31.021-.31-.154 0-.14-.072-.253-.16-.253-.09 0-.162.086-.162.191s-.148.033-.33-.16c-.18-.195-.403-.354-.494-.354-.093 0-.12-.143-.064-.323.06-.185.03-.322-.07-.322-.094 0-.172-.182-.172-.404 0-.25-.091-.403-.242-.403-.154 0-.242.155-.242.43 0 .534-.148.42-.195-.15-.019-.23-.082-.389-.14-.353s-.223-.064-.366-.222c-.25-.276-.257-.604-.028-1.181.147-.369-.1-.477-.47-.207l-.307.225.164.366c.182.406.114.77-.143.77-.101 0-.088-.097.033-.243q.203-.243.023-.242c-.098 0-.219-.163-.269-.363l-.091-.363h-.477c-.262 0-.477.083-.477.184 0 .2-.478.44-.61.308-.045-.045.01-.191.123-.327l.204-.246h-.237c-.13 0-.36.137-.511.304l-.275.304-.394-.183c-.217-.1-.395-.309-.396-.463l-.002-.28-.444.034c-.244.02-.566.182-.715.361l-.272.327-.316-.192-.315-.192-.284.208c-.313.228-.176.653.168.52.12-.045.254.072.313.272l.103.352.255-.363c.34-.482.57-.462.444.04l-.101.404h.26c.158 0 .259-.136.259-.351v-.351l.373.35c.526.495 1.087.424.59-.074-.116-.115-.053-.154.2-.126.204.022.497.047.652.054s.282.12.282.25c0 .135-.095.2-.22.153-.13-.05-.256.048-.306.237-.107.412.03.552.314.317.12-.1.268-.134.327-.075.06.059-.051.218-.245.354-.494.346-.447.65.05.325l.403-.264v.331c0 .183.109.374.242.425s.242.166.242.256c0 .103-.08.098-.217-.015-.119-.1-.268-.128-.331-.065s-.19.008-.28-.123c-.112-.161-.189-.178-.24-.052-.043.101-.219.147-.392.102-.18-.047-.315-.002-.315.107 0 .104.073.145.162.09.088-.055.16-.027.16.061s.237.184.525.211l.525.05-.008.498c-.01.633.3.648.917.046zm22.008-6.31c.215.042.52.023.677-.042.157-.064.648-.138 1.092-.163s1.163-.1 1.598-.167l.792-.12.217.296c.133.182.216.216.216.087 0-.126.104-.17.26-.11l.26.1-.093-.244c-.118-.306-.027-.306.44 0l.37.242.874-.165c.481-.091.897-.233.925-.315s.155-.109.282-.06c.126.048.19.153.141.233-.128.206.154.178.369-.037.1-.1.143-.281.096-.403-.047-.123-.005-.223.093-.223s.188.073.199.162c.01.089.03.242.04.341.013.112.433.183 1.11.187.75.006 1.088.07 1.088.206 0 .11.2.246.444.305s.58.146.746.196c.173.051.262.023.207-.065-.056-.09.07-.124.303-.08l.398.077v-.26c0-.36.204-.327.454.073l.21.335.207-.172c.114-.095.255-.125.314-.066s.106.021.106-.082-.077-.188-.171-.188-.128-.07-.076-.155.21-.11.351-.056l.256.098-.118-.387c-.139-.459-.404-.787-.404-.5 0 .106-.113.193-.251.193s-.207-.073-.152-.161c.057-.092-.08-.162-.319-.162h-.418l.167-.312.167-.313-.543.088c-.298.049-.703.003-.9-.103l-.356-.19-.083.316c-.1.382-.86.409-.864.03-.002-.155-.045-.179-.12-.067-.113.166-1.058.551-1.354.551-.075 0-.147-.163-.159-.363l-.022-.363-.071.376c-.046.238-.153.344-.296.289-.123-.047-.267-.015-.32.07-.168.272-.372.008-.277-.357l.091-.348-.227.143a.85.85 0 0 1-.51.095c-.155-.025-.282.013-.282.085s-.266.15-.591.174-.693.127-.819.231l-.228.19-.122-.198-.123-.198-.78.174c-.429.096-.895.127-1.035.07-.525-.22-1.319-.219-1.403.001-.049.128-.218.182-.412.131-.186-.048-.387.01-.464.134-.093.15-.44.21-1.113.192-.58-.016-.977.04-.977.138 0 .092-.221.143-.491.115s-.542.023-.605.114c-.13.187-.302.186-.736-.004-.164-.072-.346-.065-.403.014-.058.08-.53.153-1.05.164-.595.013-.996.1-1.08.235-.231.375.009.476.572.24.342-.143.567-.167.601-.066.064.193 1.133.195 2.425.004.51-.075.892-.1.849-.057s.01.188.12.322l.201.244.049-.406.049-.407zm11.041-6.778c.08-.2.151-.263.157-.14l.01.222.565-.091.564-.092v.223c0 .2.562.217.756.023.185-.185-.174-.912-.45-.912-.454 0-.519-.015-.87-.21-.178-.1-.414-.162-.525-.139-.11.022-.201-.103-.201-.28 0-.175-.073-.364-.162-.42-.089-.054-.161.014-.161.153s-.127.245-.283.238c-.168-.008-.2-.045-.08-.094.854-.345.11-.598-.822-.28l-.76.259-.268-.218c-.159-.129-.222-.14-.155-.028.187.311-.245.448-.465.147q-.202-.279-.312-.097-.11.18-.38-.131l-.27-.31-.216.232a.44.44 0 0 1-.483.118c-.531-.229-1.153-.27-1.153-.076 0 .125-.085.107-.242-.05-.134-.134-.242-.37-.242-.527v-.284l-.231.313c-.127.172-.163.337-.08.367.082.03.15.129.15.22 0 .092-.18.05-.399-.094-.497-.326-.875-.333-.995-.02-.052.136-.173.19-.278.122-.101-.067-.62-.12-1.152-.12h-.969l.05-.364c.029-.2-.026-.363-.12-.363s-.172.102-.172.225-.112.268-.25.321c-.144.055-.208.028-.152-.063.054-.088.023-.16-.069-.16s-.214.184-.27.409l-.103.408-.19-.26-.189-.258-1.493.074-1.493.074-.213-.213-.213-.213-.19.19-.19.19-.152-.24-.152-.242-.002.268-.002.267-.326-.085-.326-.086.184-.222c.219-.263.09-.276-.644-.066-.3.086-.503.114-.45.062.16-.161-.35-.56-.652-.508-.17.028-.349-.098-.445-.315-.177-.4-.706-.482-1.03-.162l-.204.202-.159-.282a.6.6 0 0 0-.474-.283c-.173 0-.315-.072-.315-.161s-.091-.161-.203-.161-.294-.146-.405-.323c-.208-.334-.682-.446-.682-.161 0 .088.072.161.16.161.09 0 .162.084.162.186 0 .109-.129.07-.308-.093l-.309-.279-.076.295-.076.294-.019-.372c-.01-.205-.086-.331-.169-.28-.082.051-.198.014-.258-.082s-.228-.13-.374-.074l-.266.101.202-.203c.287-.29.254-.385-.202-.593-.222-.101-.404-.302-.404-.447 0-.17-.087-.229-.25-.166-.138.052-.21.032-.162-.047.048-.078-.014-.182-.14-.23a.247.247 0 0 0-.317.145c-.049.127-.018.231.068.231.344 0 .142.66-.247.807-.222.085-.404.228-.404.319 0 .09-.109.165-.242.165-.381 0-.282.295.12.352.213.03.382.183.412.374l.05.323-.152-.222c-.083-.123-.232-.173-.331-.112-.318.197-.192.372.345.48l.524.106-.242.154-.242.154.362.002c.199 0 .45.144.558.317.116.185.266.26.364.182.188-.148 3.662.616 3.816.839.054.078.2.121.323.096.36-.071 1.435.183 1.435.34 0 .078.2.139.443.134.244-.005 1.243.177 2.219.405s2.533.457 3.46.509 1.713.121 1.747.155c.033.034.274 0 .533-.074.26-.074.472-.079.472-.01 0 .15 4.204.137 4.438-.014.226-.146 1.048.03 1.048.224 0 .089.126.109.282.045.156-.063.537-.128.847-.143.31-.016.643-.077.738-.136.179-.111 1.41.195 1.618.403.21.21.394.127.544-.245zm-3.948-5.123c.055-.089.263-.161.462-.161.364 0 .749-.27.749-.526 0-.076-.073-.094-.162-.04-.089.056-.161-.053-.161-.241 0-.197.071-.298.169-.237.093.057.293.05.444-.016.45-.196 1.037-.257 1.458-.151l.396.099-.185.185c-.276.276-.224.443.138.443h.323v-.727l.414-.024c.284-.016.389.044.332.19-.09.238.273.617.435.454.057-.056.06-.274.008-.482-.057-.228-.023-.38.084-.38.098 0 .179.073.179.162 0 .296.352.166.437-.162.047-.177.181-.322.3-.322.118 0 .292-.127.387-.283l.171-.282-.1.444c-.063.277-.034.443.078.443.099 0 .18-.145.18-.322s.072-.323.16-.323c.09 0 .162.151.162.336 0 .2.081.306.201.262.111-.04.186-.148.167-.24-.02-.091.076-.209.212-.261l.248-.095-.096.3c-.13.412.173 1.15.474 1.15.135 0 .246.073.246.161 0 .09.09.16.202.156.11-.003.002-.17-.242-.37-.509-.416-.57-.628-.162-.559.193.032.268-.043.235-.235-.026-.155.029-.282.121-.282.093 0 .169.139.169.308v.31l.363-.108c.928-.274 1.253-1.081.387-.96-.233.032-.358-.055-.399-.276-.103-.557-.3-.602-.22-.051l.077.524-.277-.277c-.152-.152-.336-.277-.408-.277s-.168-.14-.213-.312l-.081-.313-.344.09-.344.09.174.21.174.21-.317-.084a.61.61 0 0 1-.398-.39c-.099-.379-.628-.612-.725-.319l-.07.209-.125-.203c-.072-.116-.479-.21-.948-.22-.452-.009-.823-.071-.823-.138s-.078-.121-.172-.121-.126.073-.071.161c.055.09.023.162-.071.162s-.171-.211-.171-.47v-.468l-.363.091c-.2.051-.4.142-.444.203-.044.06-.273.157-.507.214l-.427.105-.109-.282-.108-.28-.164.29-.163.292-.256-.21-.255-.211.188.352c.263.493.234.658-.05.283-.133-.176-.238-.225-.241-.111-.007.256-.441.265-.526.012-.04-.12-.147-.138-.288-.051-.124.077-.447.162-.717.19-.893.094-1.236.422-.612.585.155.04.046.082-.242.092-.289.01-.525-.049-.525-.132s-.299-.147-.664-.142-.718-.078-.784-.185l-.12-.194-.098.255c-.06.156-.29.256-.588.256-.558 0-.616.157-.197.536l.291.264.361-.253c.238-.166.567-.226.96-.173 1.065.142 1.646.308 1.646.47 0 .087.109.117.242.066s.242-.023.242.063.109.156.242.156.242.11.242.242a.243.243 0 0 1-.242.242c-.133 0-.242-.058-.242-.13 0-.07-.258-.136-.574-.145l-.574-.016.05.347.05.348.472.006c.26.004.502.094.538.201s.24.196.455.196c.436 0 .545.434.148.587-.133.05-.242.158-.242.237 0 .196.44.183.564-.017zm21.54-2.34c0-.221.073-.403.162-.403s.161-.109.161-.242.11-.242.242-.242c.133 0 .242.076.242.169 0 .092.2-.031.444-.276.475-.475.495-.81.066-1.123-.316-.232-.23-.354.307-.436l.394-.06.03-.678.031-.677-.313.1c-.212.066-.313.023-.313-.136 0-.128.163-.286.363-.35l.363-.117-.266-.072c-.28-.076-.534-.7-.284-.7.08 0 .147-.078.147-.174s-.128-.145-.283-.111-.264.148-.242.254c.064.306-.062.225-.363-.233l-.278-.426.453.114.453.113-.395-.333-.394-.334.313-.242.313-.242h-.282c-.156 0-.242-.066-.192-.146s.235-.108.413-.062c.341.09.47-.326.16-.518-.088-.055-.16-.01-.16.1 0 .113-.164.045-.38-.158-.399-.375-.572-1.391-.215-1.266.105.037.168.194.14.349s-.011.387.038.515l.089.232.307-.164.308-.165.086.331.087.33.362-.193.362-.194.214.293c.118.162.215.207.215.102 0-.106.145-.193.323-.193.195 0 .327-.11.333-.282l.01-.282.176.363c.238.494.713.468.811-.045.051-.266-.012-.462-.183-.565l-.26-.158.443-.368c.244-.203.444-.43.444-.504s-.102-.05-.228.055c-.144.12-.263.13-.326.03-.054-.088.022-.227.168-.309s.237-.238.2-.346c-.042-.127-.216-.047-.487.225l-.423.422.024-.393c.013-.216.073-.363.133-.326.151.094 1.253-.469 1.258-.641.003-.077-.175-.106-.394-.064s-.424-.004-.457-.1c-.036-.11-.167-.069-.34.103-.154.155-.348.281-.43.281-.205 0-.19-.28.022-.41.095-.059.137-.2.092-.316-.049-.128.08-.24.332-.287l.412-.08.08.305c.043.167.187.304.32.304.153 0 .204-.093.142-.255a1.5 1.5 0 0 1-.098-.403c0-.082-.127-.15-.282-.154l-.283-.005.27-.205c.356-.27.3-.74-.149-1.235-.423-.469-.457-.647-.12-.647.133 0 .242.109.242.242s.072.242.16.242c.09 0 .162-.145.162-.323 0-.177.082-.322.181-.322q.18-.002-.034-.26c-.12-.144-.219-.525-.222-.848l-.006-.587-.282.048c-.174.029-.354-.11-.468-.358-.101-.223-.241-.37-.311-.327s-.179-.006-.243-.11l-.116-.187.442.11c.242.062.574.07.736.018l.295-.094-.033-.721c-.018-.397-.102-.702-.187-.68-.086.024-.147.28-.137.571l.019.528-.342-.106c-.187-.059-.386-.176-.44-.26s-.265-.13-.469-.1-.4-.03-.435-.135c-.037-.11.127-.212.388-.242l.454-.052.05-.686c.029-.408.13-.686.247-.686.11 0 .21-.149.224-.331.03-.41-.558-.667-.956-.419-.32.2-.542.057-.362-.234.176-.286.225-1.597.059-1.597-.077 0-.098-.11-.047-.242.051-.133.236-.242.412-.242.186 0 .289-.084.247-.202-.04-.11-.224-.185-.41-.164l-.34.037.092-.239c.05-.131.19-.239.31-.239s.264-.251.323-.565c.06-.323.201-.564.33-.564.123 0 .224-.073.224-.162a.164.164 0 0 0-.165-.161c-.09 0-.248-.182-.349-.405-.101-.222-.263-.395-.36-.384-.392.045-.592-.027-.498-.18.055-.088.025-.16-.066-.16-.09 0-.123-.11-.072-.244l.094-.244-.262.1c-.143.055-.305.274-.358.486s-.17.385-.26.385c-.089 0-.124-.145-.078-.322.047-.178.019-.283-.061-.233s-.147.014-.147-.08-.109-.171-.242-.171-.242.077-.242.17c0 .095.073.127.162.072.088-.055.16-.018.16.083 0 .1-.126.156-.281.124-.193-.04-.274-.194-.254-.486l.03-.428-.433-.172-.432-.173.766.08c.432.044.766.011.766-.075 0-.084-.09-.12-.201-.08-.111.041-.306.009-.434-.073l-.231-.147.212-.256c.13-.156.204-.63.19-1.214l-.02-.958.263-.148.263-.147-.193-.12c-.106-.065-.206-.093-.222-.062l-.312.566c-.156.28-.283.66-.283.847s-.072.338-.161.338c-.209 0-.204-.195.02-.756.314-.79.3-1.16-.047-1.27-.19-.06-.284-.193-.232-.328.048-.125.017-.228-.069-.228s-.148-.054-.137-.12c.055-.347-.048-.525-.301-.526l-.283-.002.41-.282c.243-.166.387-.396.352-.563-.086-.41.096-.348.62.213l.463.495.23-.213.23-.213-.154-.291c-.085-.16-.123-.378-.083-.484s.156.02.26.279c.102.259.152.56.111.667-.048.124.033.168.22.119l.295-.077-.139-.485c-.076-.267-.22-.584-.321-.705-.1-.12-.126-.31-.057-.421.07-.112.11-.442.09-.734l-.036-.53h.337c.186 0 .295-.07.242-.154-.052-.085-.22-.11-.372-.057-.195.068-.23.044-.116-.08.088-.097.448-.206.799-.241.35-.036.665-.15.699-.251.037-.111-.04-.146-.193-.088-.148.057-.292-.003-.346-.143-.097-.252-.717-.196-.717.065 0 .078-.11.142-.242.142-.36 0-.293-.5.08-.599.389-.101.397-.157.074-.48q-.249-.25-.726-.154l-.477.096v-.498l.323.102c.33.105.453-.142.161-.322-.23-.143-.2-.565.04-.565.23 0 .285-1.243.07-1.574-.082-.128-.033-.24.131-.304.144-.055.225-.196.18-.313s.06-.258.233-.313c.352-.112.38-.211.153-.562l-.157-.242-.003.283c-.002.155-.075.282-.163.282-.212 0-.208-.534.006-.748.114-.114.115-.304.004-.596-.09-.235-.11-.42-.047-.41.372.056.487-.097.58-.771q.173-1.274.678-1.079.231.09.23-.251c0-.233.102-.34.323-.34h.323v-.555c0-.306.072-.6.161-.655s.153-.295.142-.534l-.019-.434-.103.484c-.057.266-.188.484-.29.484a.5.5 0 0 0-.308.12c-.235.236-.412.117-.36-.241l.05-.363.364.05c.2.028.362-.009.36-.08-.004-.223-.267-.564-.419-.542-.078.01-.166-.128-.195-.31-.063-.403.256-.429.572-.046l.232.282-.088-.282c-.05-.155-.027-.283.048-.283.076 0 .177-.15.225-.332l.087-.333-.35-.14-.351-.142.323-.013c.2-.008.252-.057.137-.13-.102-.066-.211-.301-.242-.523l-.057-.403-.605.01-.605.01-.01-.252c-.006-.152-.07-.104-.16.121-.087.216-.27.36-.434.343-.47-.05-1.332.384-1.332.671 0 .147-.11.358-.242.469-.133.11-.242.29-.242.4 0 .127-.15.172-.406.123l-.406-.078.1.26c.063.165-.006.3-.19.371-.164.063-.315.033-.35-.07-.073-.22-.684.265-.684.545 0 .338-.955 1.231-1.21 1.133-.148-.056-.243 0-.243.144 0 .26-.252.32-.391.094-.134-.216-1.06-.313-1.066-.111-.023.782-1.166 1.247-1.999.813-.323-.168-.523-.193-.637-.08-.092.092-.329.167-.528.167-.405 0-.616.232-.452.498q.108.177.27.012c.11-.11.293-.104.56.017l.395.18.31-.194.311-.194v.648h.39c.215 0 .427.091.472.202l.082.202.157-.225a.37.37 0 0 1 .416-.126c.285.109.352.42.097.452-.089.01-.252.029-.363.04s-.273.184-.361.383c-.088.2-.215.363-.282.363-.068 0-.124.182-.124.404 0 .25-.09.403-.242.403-.133 0-.242.073-.242.161 0 .09.11.162.242.162.326 0 .31.591-.02.776l-.263.147.203.126c.123.076.262.021.352-.14.24-.428.367-.311.565.524l.187.788-.172.704c-.094.388-.275.825-.4.97-.126.147-.162.292-.08.323.083.032.201.22.263.42l.113.364h-.253c-.139 0-.252-.078-.252-.173 0-.188-.552.307-.585.524-.053.344-.082.356-.235.092-.176-.302-.633-.39-.633-.12 0 .088.087.16.193.16.105 0 .054.102-.115.225l-.307.225.215.26c.271.326.518.337.395.017-.05-.133-.02-.242.067-.242.326 0 .334.656.01.957l-.32.3.19.118c.106.065.253.02.327-.1s.193-.159.264-.087c.184.184-.563.75-.846.642-.129-.05-.234-.01-.234.089s.07.178.155.178.158.2.163.444c.023 1.259.041 1.351.25 1.271.116-.044.252.023.3.15.059.151-.016.233-.21.233-.166 0-.344.113-.398.252l-.097.253.341-.108.34-.108-.074.218c-.042.12-.268.216-.503.212-.301-.004-.428.077-.428.273 0 .358-.281.533-.532.332-.107-.086-.462-.186-.79-.223l-.595-.066-.064.249c-.092.356.043.672.237.552.107-.066.098-.143-.028-.22l-.192-.12.236-.09c.146-.056.301.055.41.292l.173.382-.298.095c-.165.052-.36.084-.437.07-.696-.125-.97.438-.714 1.466.077.31.148.48.157.378l.016-.187.402.187c.501.232.519.518.042.663-.22.066-.284.143-.161.193.11.046.201.253.201.46s-.09.41-.201.452c-.14.052-.103.154.12.331l.323.255-.322.003a3 3 0 0 1-.679-.092l-.355-.095.092-.461.092-.462-.589.053c-.323.03-.64.105-.704.169s-.044.101.045.083.327-.024.53-.013l.369.019-.173.323c-.095.177-.263.322-.373.322s-.32.139-.464.308l-.263.308.308.08c.17.045.308.16.308.257 0 .229-.432.23-.573.002-.07-.113-.164-.12-.265-.019s-.083.275.052.49l.208.335-.154.438c-.176.498-.559.708-.559.307 0-.145-.072-.22-.161-.165s-.161.277-.161.494c0 .232-.094.393-.229.393-.126 0-.253.057-.282.126-.03.07-.308.25-.619.4-.361.175-.457.275-.265.278l.3.004-.101.403c-.059.233-.032.403.063.403.332 0 .153.464-.199.513l-.363.052.04.645c.023.355.114.67.203.7s.122.12.072.202c-.05.08.026.147.17.147.143 0 .218.068.167.152-.111.18.53.816.821.816.112 0 .254.084.318.187.067.108.044.142-.055.081-.093-.057-.213.01-.266.148q-.097.25-.42.15c-.193-.062-.324-.03-.324.078 0 .1-.072.137-.16.082-.092-.056-.162.08-.162.314 0 .227.09.414.201.415l.202.002-.203.13c-.134.084-.169.306-.101.642l.102.514h.318c.18 0 .354.137.4.317l.083.317.244-.244.244-.244.305.275c.382.346.55.202.302-.26-.103-.193-.145-.392-.093-.444s.093 0 .093.113c0 .127.124.175.32.124l.32-.084-.147.275a.52.52 0 0 0 0 .509c.252.398.18.667-.151.562l-.305-.097.162.772c.089.424.232.859.318.966.165.204.047.531-.192.531-.077 0-.164-.148-.192-.329l-.052-.329-.205.332-.204.332.406.154c.224.085.407.228.407.318s.163.146.363.125l.363-.038-.023.282c-.012.155.042.282.121.282.08 0 .152-.163.162-.363l.02-.363.075.294.076.294.193-.264.193-.264.52.496c.312.299.518.656.518.898v.402h.417c.263 0 .391.074.348.202-.038.11-.225.179-.417.15-.39-.056-.448.12-.146.446.118.128.126.175.018.115-.1-.057-.282.019-.403.168l-.22.27.282-.106c.277-.104.294-.072.348.675.01.124.162.277.339.34l.322.114-.525.117-.524.116v.39c0 .215.072.391.161.391s.162-.154.162-.342v-.343l.235.195c.129.107.316.145.415.084.1-.062.324.04.498.228.174.187.414.34.535.34.12 0 .262.176.316.392.136.542.532.898.997.898h.392v.328c0 .18.108.37.241.42.133.051.206.15.162.22-.11.179.23.272.847.233.578-.037.665.165.288.664-.13.173-.24.446-.242.607l-.005.294.363-.043c.424-.051 1.089.33 1.089.624 0 .112.109.203.242.203s.244.09.247.202c.003.129.057.112.15-.046.11-.187 1.055-.327 1.055-.157 0 .18.677.073.832-.13.118-.155.209-.19.212-.08a.37.37 0 0 1-.156.292c-.244.15-.194.403.08.403.15 0 .242-.152.242-.403zm-18.07-16.027c0-.082.104-.236.232-.342s.193-.296.144-.423c-.097-.253-.04-.277.326-.136.135.052.206.197.157.323-.048.125-.015.228.074.228.219 0 .368-.428.254-.726-.078-.204-.613-.334-1.07-.26-.068.011-.08-.155-.027-.369l.098-.39-.336-.106a.43.43 0 0 1-.318-.459l.019-.352.072.273.072.272.312-.313c.583-.583 1.072-.36.973.442-.038.308.256.39.471.131.256-.308.483-.308.483.002 0 .301.327.312.721.023.187-.137.26-.32.195-.49l-.105-.273-.328.176c-.343.183-.645.097-.645-.183 0-.09-.103-.267-.23-.394l-.231-.231-.07.363-.07.364-.023-.484c-.012-.267-.163-.716-.336-.998-.205-.338-.25-.535-.131-.575.1-.033.135-.182.078-.33-.063-.162-.204-.232-.354-.174-.138.053-.355.009-.483-.097-.128-.107-.296-.155-.372-.108s-.26-.118-.407-.368l-.268-.453-.388.074c-.213.04-.437-.006-.497-.103-.193-.311-.374-.189-.446.3l-.07.478.333-.033.334-.034.054.404.055.403-.207-.202c-.114-.11-.284-.2-.377-.199s-.061.071.071.155l.24.152-.2.2c-.294.295-.244.535.06.283l.259-.215.202.276c.111.152.285.276.386.276s.184.073.184.162c0 .088-.11.16-.242.16-.133 0-.242-.072-.242-.16 0-.09-.167-.162-.371-.162s-.459-.087-.565-.193l-.194-.194-.193.194c-.245.244-.775.253-.775.012v-.181l-.232.193c-.128.106-.436.169-.686.14l-.453-.052.04-.376c.05-.458-.335-.396-.42.067-.031.17-.159.424-.283.564s-.177.304-.118.364c.186.185.377.118.377-.135 0-.133.11-.242.242-.242.133 0 .242.068.242.15 0 .084.152.2.338.258l.337.108-.088.339c-.05.186-.01.433.085.549l.175.21-.201.242c-.11.133-.141.242-.068.242s.045.087-.061.194c-.27.268-.243.505.044.395.13-.05.305.029.388.176l.15.268.257-.213.258-.214v.561l.332-.087c.204-.053.367.002.421.143.049.126.264.23.48.23.217 0 .437.12.495.27l.104.273.196-.635c.127-.41.203-.513.214-.29.009.19.119.386.243.433.352.136.446-.077.134-.305-.153-.113-.219-.265-.144-.339.21-.209.74.559.662.96-.037.196-.142.382-.231.411-.09.03-.163.171-.163.314v.259l.322-.347c.178-.19.323-.413.323-.494zm-9.578-14.306c-.012-.222-.08-.404-.15-.404s-.046-.15.052-.333l.178-.333-.186-.224c-.103-.124-.135-.309-.072-.41l.115-.186.114.184c-.37-.598.663-.31.935-.299.168.008.2.046.08.095-.257.103-.206.094.067.264.164.101.23-.042.152.085-.064.104-.024-.117.073-.117s.2.21.245.091c.207-.541 1.172.231 1.346-.067l.165-.283.005.283.005.282.443-.022.444-.022-.363-.07c-.437-.084-.454-.184-.08-.468.349-.265.537-.282.483-.043-.022.1.033.209.121.242.133.05.17-.465.093-1.27-.006-.067-.12-.122-.254-.122-.133 0-.242-.072-.242-.16 0-.206.056-.203.55.022l.405.184-.155.29q-.156.29.02.399c.236.145.432-.08.498-.573q.053-.405.408-.454c.208-.03.44-.246.564-.526.116-.262.338-.517.493-.566.307-.097.39-.39.11-.39-.095 0-.129-.136-.075-.304l.096-.304-.408-.103c-.26-.065-.408-.215-.408-.412 0-.428-.326-.593-.425-.216l-.08.307-.548.015c-.462.013-1.068-.342-.924-.541.106-.147.021-.379-.138-.379-.098 0-.138.106-.089.235l.09.235-.406-.154-.407-.155-.19.202c-.105.111-.215.419-.243.684-.03.265-.126.57-.216.679-.09.108-.116.272-.06.365.193.31-.233.172-.6-.195l-.363-.363-.05.354-.05.354-.26-.1-.26-.1.093.246.094.244-.429-.068-.429-.068.235.163.234.163-.604-.047c-.331-.027-.58.02-.552.103.027.084.105.144.173.134s.24.1.385.244l.262.263-.218.135c-.139.086-.286.043-.404-.118l-.185-.253-.308.179c-.174.101-.216.181-.097.184.116.003.162.084.103.18l-.109.176-.175-.176c-.22-.22-.487-.23-.353-.014.055.09.696.245.506.245-.413 0-.433.259-.01.321.415.061-.083.285.006.844l.076.485-.306.08s.19.819-.03.432c-.29-.511.408.895.34.296.385.196-.088-.141.554-.744l.282-.265.996 1.2c.24.29-1.052.656-.877.656.068 0 .113-.181.1-.403zm30.014-29.486c.045.111.157.157.247.1.107-.065.096-.144-.03-.222-.111-.069-.152-.26-.095-.441l.101-.32.44.068c1.024.156 1.155.212 1.063.452-.128.335-.018.302.505-.147.277-.238.415-.484.357-.635-.052-.136-.025-.27.06-.298.184-.062.338-.764.211-.969-.05-.081-.198-.056-.332.055l-.242.201.028-.637c.016-.35-.024-.806-.088-1.012l-.116-.375-.366.092-.366.092-.169-.483c-.092-.266-.268-.484-.39-.484-.156 0-.202-.146-.152-.484l.071-.484h-.412c-.227 0-.46-.076-.517-.169-.072-.116-.175-.11-.328.017l-.224.185-.191-.42c-.22-.481-.692-.551-.933-.137-.092.157-.167.192-.17.08-.008-.312-.325-.237-.343.081q-.017.283-.146-.12c-.07-.223-.136-.313-.145-.202s-.16.201-.336.201c-.196 0-.354.14-.41.363l-.093.363-.663.01c-.366.004-.58-.02-.478-.054.126-.042.104-.144-.069-.317l-.255-.255-.145.227c-.19.303-.186.59.013.712.088.055.161.203.161.329v.23l-.403-.185-.404-.183-.025-.499a10 10 0 0 1-.01-.821c.008-.178-.022-.236-.066-.13s-.178.155-.296.11c-.323-.124-.732.577-.732 1.254v.598l-.283.073c-.197.052-.16.083.121.103l.404.03-.348.14-.347.14.016.569.016.569.217-.18c.15-.125.166-.232.05-.349-.233-.232-.212-.589.033-.582.271.007 1.089.738 1.089.975v.188l.232-.192.233-.193-.185.39-.184.391-.186-.173a.58.58 0 0 1-.169-.402c.01-.126-.075-.261-.186-.3l-.203-.072.148.39c.083.218.088.489.011.613l-.137.222-.317-.286c-.335-.304-.578-.148-.418.268.125.325.696.456 1.084.249l.316-.17-.11.178c-.063.101.003.177.151.177.147 0 .214.077.153.176-.06.096-.245.14-.413.096-.199-.053-.304.005-.304.164v.243l1.278-.113c1.414-.125 2.271-.006 2.271.316 0 .22.895.425 1.256.288.125-.048.166-.206.103-.402q-.101-.323.076-.214c.324.2.204.898-.184 1.069l-.363.16.405-.078c.224-.043.587.014.807.127.28.143.442.153.535.034.091-.118.159-.108.215.031zm-12.399-2.26.051-.444h-.263c-.254 0-1.335-.72-1.565-1.043-.061-.087-.162-.107-.223-.046-.062.061-.302-.022-.534-.185a3.5 3.5 0 0 0-.784-.41c-.339-.105-.442-.282-.373-.642.015-.082-.078-.06-.209.048l-.236.196-.216-.307c-.12-.17-.398-.364-.62-.434s-.82-.402-1.328-.74c-.508-.336-.967-.543-1.02-.458-.053.087-.276.012-.509-.171-.227-.18-.53-.327-.674-.33-.143-.002-.696-.155-1.229-.34-2.533-.883-7.18-.948-7.18-.1 0 .067-.178.122-.395.122s-.46.114-.537.253-.335.38-.572.535l-.43.282.2.267.201.267.554-.272.553-.271.065.195c.036.108.13.196.208.196.079 0 .101-.109.05-.242q-.093-.242.207-.245l.3-.003-.242-.156c-.134-.086-.17-.167-.081-.18l.484-.064c.177-.022.395-.064.484-.093.376-.12 1.83.197 1.914.418l.09.236.49-.098.488-.097.313.383.312.382.205-.201c.24-.235.976-.268 1.198-.054.205.197 1.07.275 1.324.119.117-.073.533.055.994.306.436.237.89.397 1.008.355s.406.019.638.136c.233.118.69.241 1.018.275.564.057 1.544.85 1.544 1.247 0 .08.164.233.364.34l.363.193-.21-.255c-.115-.14-.152-.289-.08-.331.176-.107.961.777.887 1-.033.098.046.178.176.178s.326.108.435.24c.11.133.264.2.343.152.078-.048.143-.017.143.07 0 .216.434.32 1.21.29l.645-.026z",
    style: {
      fill: "#ac695c",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M84.31 181.69c1.562-1.547 1.638-2.147 3.118-1.93-.192-2.238 1.301-2.632 2.12-3.835 2.04-.167.029-1.1-.191-.918-1.365 1.606.151-1.288.761-1.247 2.419-1.758-.606 1.037.524 1.696.63-1.028 1.91.23 2.359-1.016.846-2.746-1.23-.114-.989-2.65 1.894-.395.294-.521 1.386-2.522-1.319-2.32 2.597-1.224 2.167-2.141 2.18-.08 1.452-.87 1.344-1.66-1.823 1.264-3.194 1.724-1.395-1.083.03-1.453-2.667-1.052-.677-1.483.467-1.722 1.507-3.513-.282-3.9.482-1.299-.117-3.835 1.21-1.111 1.866-2.237 2.916-.792 4.107-.146 1.005-.823.19-2.969-.719-4.01 1.397-2.255 1.72-1.017 3.289-1.86 1.488-.931-.16-1.901.914-3.378 3.23-.417.443-.333 1.338-2.743.897 1.603 2.804-.506 1.254-.588 1.098-1.204 4.308-2.5 4-.788-.146-1.81 2.383-2.824.172-3.226 3.133.529 1.686-2.014 4.217-2.95 1.671-.428-.086-3.65-1.353-1.14.031-.057-3.118-1.316-3.186-1.753-1.04-2.785 1.99-2.491 2.814-4.059-1.697.814-.513-.286.507-1.346-1.413.205-1.285.038-.446-1.034-2.09.907 1.549-1.758-.339-1.959-.08-.06 2.143-.926-.03-1.715.842-.715-2.28.357-.565-.849 2.147.117.678-1.528-.722-1.43 2.397-1.19-2.58-1.972.78-2.986 1.488-1.571 1.143-1.737 2.59-2.44-.75-1.002-1.213-1.387-2.175-2.554 1.662-2.74.916 2.46 2.183-.903.21-.989.234-2.19 2.346-2.322 2.126-1.3-2.235-1.335-.03-2.605.27.779 2.13-2.678 1.452-.478-.82.315-.485 1.735 1.035.177-.33-1.593 2.335-1.523 1.738-.47.656 1.397.948 1.316 2.61 1.535-.051 1.54 1.586 1.55 1.926 2.754 1.184-1.248 1.303 2.119 2.281.276.433 3.136 2.023.64 3.68 1.279 1.073-.924-.06-3.473 1.71-1.875.876-1.718-.764-2.372-.277-3.7-2.715-1.848-.021-2.941.222-1.65-.894 1.395.75-2.674 1.088-.015-.159-1.396-.04-3.173-.5-3.976-1.472.449 1.367-3.343-.77-1.206-.323-2.76 2.277-1.471 1.285-2.544.407-.958-.066-2.315 1.086-3.755-2.594-.581 1.232-1.343-.85-2.442-.768-.616 1.012-2.2-.514-2.962 1.607-.525-.248-2.763 1.866-4.736-.092-2.687.927-2.578.375-4.675-.024-1.107.726-1.727-.445-2.403 1.498-1.44-.369-2.343 1.523-1.801-.487-2.805-1.411-.712-.689-3.203-1.853 1.16.206-1.899-1.617-.366.905-1.37-2.295-2.272-.206-3.07.025-1.085-.277-3.563-.675-4.235 1.21-1.17.722-1.81.218-3.638-1.398-.772 1.216-1.605-1.092-2.935 2.198-.892-2.489.552.418-2.068.822-1.961 1.596-2.383.914-4.466-.87-1.744-.789-1.926-1.057-4.075-1.104-.99.434-4.27-.328-1.405.1.496 2.144-3.421 2.121-3-2.349-1.925-.625-1.92-1.006-3.237.298-2.136-.707.652-.712-1.565-.775-.906 4.247-.95 1.568.65 5.866 8.946 5.852 20.526 5.902 30.98-.442 13.981-1.435 27.99-3.354 41.833-.7 2.56.656-5.996.721-7.632 1.372-14.392 2.8-28.85 2.23-43.327.006-3.902-1.135-8.026-1.704-12.117-1.04.96-.301 5.36.333 7.409-.658 2.567.268 6.262-.146 7.725.626.96-.228 1.81.163 3.804.771 2.54-.68 6.132-.233 8.992-.45 2.034.375 1.825-.331 4.376-.31 1.946-.134 4.522-.406 5.507-.94 1.727.7 4.105-.261 6.14-.834 4.188-.574 5.944-1.105 10.27-.357 3.018.045 4.766-1.06 6.658.555 3.409-1.794 5.965-3.282 8.439-.552.446-1.062-.159-2.328.225-.82.126-.165 3.384.407 2.08.627 1.856-1 2.89-.268 4.875-.174-.61-1.963 1.123-1.605 2.178.76 1.018-2.238 3.67-1.524 4.034-.55 1.947.693 2.58-1.139 1.04.54 1.321-.834.304-.23 2.233-1.876-.008-1.961 2.35-1.605 2.616.968-.7-.554 1.386.16 1.502-1.586 1.118 1.107.125-.807 1.231.97 2.146-.952 2.76-.864 3.589.614 2.386-.518-1.01-1.304 1.196.925 1.05-.348 4.41-1.347 2.745 1.424 2.428-1.625.9-.495 3.832-.922-.433-1.015 2.326-2.99 1.143-.242 2.039-1.604 2.126-.925 3.883.124.997-4.461-.486-2.125.96-1.098.112-2.048 2.442-2.232 1.69-2.49-.719-1.093 2.675-2.56 1.728-.607 3.717 1.291-1.606.837 2.721-.837.525-1.33-2.913-2.682.04 1.22-.032-2.612.868.966.895.389.963-.278 2.397-2.13 2.824 1.8 2.784-3.796 1.796-1.611 3.443.422.505-2.457-1.268-.512.705-1.78 1.379-.826 3.446-2.104 3.544-.18-2.772-.394 3.501-.675.752-.108-1.982-1.868.725.921 1.63-.066-2.398.74 3.576-1.27 1.991 2.2 2.156-5.744 1.344-8.054 1.602-1.819-.15-4.037.29-5.625-.201.061.31-1.828.2-2.527.081m-13.158-60.454c-2.645-1.534 1.33-.554-.344-1.7-.418-.597-.06-1.596-2.012-1.547-.249.672-1.936.538-2.068-1.21-.117 1.407 2.25-.729 3.367.937.725-1.514 2.986.825 2.707-.086.43-1.852.988 2.676 1.826 1.495-.436 2.85 6.811 1.422 4.668 2.437-1.236-.297-4.443.894-5.615-1.325-1.685-.18-.65-.278-2.477 1.358zm22.235-5.77c-1.632-.31-7.61-.092-2.035-.856 3.035-.455 6.65-.938 9.308-1.09 2.384-.406 1.733.31 4.017-.351.757.184 2.834-.506 2.951.55 2.047.136.683 2.125-.407 1.23-1.696.698-4.576-1.346-5.516-.578-2.354.628-2.393.294-4.26.229-1.397.108-4.003.267-4.058.867m11.188-7.027c-4.325-.725-8.938.093-13.435-.64-3.795-.706-7.688-1.607-11.268-2.635.251-.811-.945-.982.409-2.9 1.132-.743 1.823 2.622 2.683 1.645.352-.465 2.9 1.529 4.471 1.628 1.796.916 1.356.23 3.475.692 2.14.383 3.392-.648 3.812-.055 3.421.443 3.263-.894 5.585.193 1.591-.177 2.396.567 4.39-.08-.683.416 4.74 2.32.588 1.99.018-.774-.372.764-.71.162m-3.97-5.35c1.124-1.178-3.719-1.992.162-1.874-2.115-.966-6.463-1.1-2.44-1.503 1.621.495 3.93-1.157 4.183-.662.47-.643 2.62-.48 2.776.108 2.715.848 2.936.225 4.448 1.447.848-1.119 1.33 1.666-.22.812.022 2.674-.867-1.867-1.988.04-.22-1.893-1.63 1.985-2.633.237.404 1.55-2.95-1.427-2.75 1.049-.492-.05-1.115.713-1.537.345m-5.868-32.92c.252-2.708-.936 1.574-1.07-.51-.41 1.84.635-2.392-.487-2.246 1.533-.396 1.452-.577 2.046-1.174.316.222.752-1.728 2.107-.456.417-3.445 1.643-1.185 3.17-1.645 2.394.271.383 3.29-.945 3.694-.14-2.218-1.05 1.46-.485 1.15-1.437-.342-1.825.08-3.146-.27-.722-1.586-1.113 2.463-1.19 1.456",
    style: {
      fill: "#a96055",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "M138.733 49.447c-.599 1.656-.272 5.311.484 7.525-.793 2.367.587 6.173-.316 7.482.778.037.31 1.885.336 2.043-.17 2.363.589 5.275-.139 8.324-.634 1.337.307 4.195-.35 4.36.842 1.631-.688 4.335-.41 6.493.243.948-.03 2.544-.471 3.155.74 2.97.521 5.822-.813 8.62.847 2.178-.302 5.065-.21 7.975-.041 3.066-.538 3.147-.842 5.574.145 3.22-2.029 5.224-3.167 7.748-1.86 1.25.44-.75-2.379.298-.746-1.28-.973 4.24.251 1.789.149 1.225-.204 3.045-.562 3.76.759 2.629-.145.68-.96 1.994-.575 2.15-.205 2.433-1.38 4.67-1.95.364.712 4.812-1.705 2.057-.103.81.626.818-.71 1.125 1.906 1.37-1.954 1.152-1.291 2.925-.04 1.268.983-.325.184 1.875 1.013-1.046-1.691 2.137.365.922-1.86.127-.02 3.36-1.533 3.248-.456.03.48 2.537-.784 1.823-.193-1.493-.913 1.02-.468 2.21-1.646.455.028 2.47-1.893 1.089 2.385 1.717-1.108 1.268-.597 2.064.772 1.228-1.02 2.5-1.514 3.203-1.2-1.725-2.127 1.822-2.045 1.913-1.067 1.505.74 2.346-1.819 1.936-.349-.59-2.016.179-.476.876-1.306.006-1.492.822-2.117 1.89.393-1.12-2.577-.004-2.045 1.159.245.178-1.873 1.478-.105 1.63-.007-2.228 1.12 2.235-.64 1.093.988-2.253-2.696-.498-1.133.126-3.272.565 2.305 1.078.245 2.12-.041 1.427-2.673 1.203-1.746 2.707-.029 2.088-4.205.527-1.56 2.526-2.902-1.737.56 1.22-1.715 2.13-.467-.551-.613 4.02-.968 1.368-1.002-.964-.184 3.319-.931 1.632.265-1.2-1.006-1.768-.412.49 2.73.871.924-.156 1.332 3.084-2.962-.45 1.338.813-1.964 1.17-.665-1.51.49 1.262 2.712.114 1.913-.19 4.321.284 6-.235-.96-.946 1.09-1.24-.092-1.911 1.8-.85.812-2.318 1.822-3.293.76-1.052-.537-1.493.348-2.662.916.375.734-.766.542-1.694.955-.036.172-1.956 1.697-3.498-.402-1.031 1.683-2.99 2.149-4.977-1.034-.353 1.907-2.702 1.966-3.3.176-1.123 2.393-3.066 2.81-4.857 1.154-1.023 1.558-2.817 2.897-5.451.493-1.527 2.465-4.033 1.882-5.491 1.473-3.268 2.805-6.783 4.366-9.902 1.617-2.704.473-3.425 2.317-5.458-.522.059 1.67-4.305 1.276-4.767-.219-3.42 1.235-3.495 2.458-6.351-.166-.712 2.809-3.191 2.57-5.163 1.804-16.118 3.47-32.314 3.192-48.554-.014-3.856-.406-7.203-1.175-11.065-.218-1.2-.277-2.62-.764-3.686",
    style: {
      fill: "#90400c",
      fillOpacity: 1,
      strokeWidth: 0,
      stroke: "none",
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leftPageLayer",
    className: "hide",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M79.491 21.23 46.121 1.352",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3-7",
    d: "m79.558 164.31-32.79 17.197",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m47.652.663.37 179.72 33.094-17.848-.634-141.877Z",
    style: {
      fill: "#f7f9f3",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.00208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M70.597 15.677v152.459l10.724-6.043-.249-141.275Z",
    style: {
      fill: "url(#linearGradient6)",
      stroke: "none",
      strokeWidth: 0.961897,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-1-7",
    d: "M44.935.467v181.567",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "FlickerLayer-75percent",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M208.977 63.546v98.676l-6.457.775V61.996Z",
    style: {
      fill: "#fff",
      strokeWidth: 0.799999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      paintOrder: "stroke fill markers",
      filter: "url(#filter5)"
    },
    transform: "matrix(5.83004 0 0 1.64506 -877.01 -93.928)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FlickerLayer-50percent",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5-9",
    d: "M208.977 63.546v98.676l-6.457.775V61.996Z",
    style: {
      fill: "#fff",
      strokeWidth: 0.799999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      paintOrder: "stroke fill markers",
      filter: "url(#filter5-8)"
    },
    transform: "matrix(6.23296 0 0 1.64506 -1059.075 -93.928)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FlickerLayer-25percent",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5-9-8",
    d: "M208.977 63.546v98.676l-6.457.775V61.996Z",
    style: {
      fill: "#fff",
      strokeWidth: 0.799999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      paintOrder: "stroke fill markers",
      filter: "url(#filter5-8-0)"
    },
    transform: "matrix(6.4303 0 0 1.64506 -1189.113 -93.928)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LeftPageStack",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-40",
    d: "M.293.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-39",
    d: "M1.38.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-38",
    d: "M2.466.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-37",
    d: "M3.553.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-36",
    d: "m4.64.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-35",
    d: "M5.726.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-34",
    d: "M6.813.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-33",
    d: "m7.9.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-32",
    d: "M8.986.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-31",
    d: "M10.073.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-30",
    d: "m11.16.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-29",
    d: "M12.246.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-28",
    d: "M13.333.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-27",
    d: "m14.42.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-26",
    d: "M15.506.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-25",
    d: "m16.593.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-24",
    d: "m17.68.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-23",
    d: "M18.766.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-22",
    d: "M19.852.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-21",
    d: "m20.94.352-.002 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-20",
    d: "M22.026.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-19",
    d: "M23.112.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-18",
    d: "M24.199.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-17",
    d: "m25.286.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-16",
    d: "M26.372.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-15",
    d: "M27.459.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-14",
    d: "m28.546.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-13",
    d: "M29.632.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-12",
    d: "M30.719.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-11",
    d: "M31.805.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-10",
    d: "M32.892.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-9",
    d: "M33.979.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-8",
    d: "M35.065.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-7",
    d: "M36.152.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-6",
    d: "m37.239.352-.001 181.567v0",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-5",
    d: "M38.325.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-4",
    d: "M39.412.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-3",
    d: "M40.607.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-2",
    d: "M42.02.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-stack-pg-1",
    d: "M43.541.352v181.567",
    className: "hide",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.703268,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "RightPageStack",
    className: "show",
    style: {
      display: "inline"
    },
    transform: "translate(.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-1",
    d: "m415.364 14.673-.001 154.635v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.650535,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-2",
    d: "M414.274 14.504v154.972",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.650537,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-3",
    d: "M413.185 14.336v155.31",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.651107,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-4",
    d: "M412.097 14.167v155.647",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.651743,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-5",
    d: "M411.009 13.999v155.983",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.652397,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-6",
    d: "M409.92 13.83v156.32",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.653052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-7",
    d: "M408.833 13.661V170.32",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.653727,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-8",
    d: "M407.745 13.493v156.995",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.654407,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-9",
    d: "M406.657 13.324v157.333",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.654738,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-10",
    d: "M405.57 13.156v157.837",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.656104,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-11",
    d: "M404.482 12.988v158.174",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.656788,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-12",
    d: "m403.395 12.82-.001 158.51v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.657462,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-13",
    d: "M402.307 12.651v158.847",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.658158,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-14",
    d: "m401.22 12.483-.001 159.184v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.658844,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-15",
    d: "M400.132 12.315v159.52",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.659524,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-16",
    d: "m399.045 12.146-.001 159.857v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.660201,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-17",
    d: "M397.957 11.978v160.194",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.660888,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-18",
    d: "M396.87 11.81v160.53",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.66157,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-19",
    d: "m395.783 11.641-.001 160.867v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.662256,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-20",
    d: "M394.695 11.473v161.204",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.662933,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-21",
    d: "M393.608 11.304v161.541",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.663614,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-22",
    d: "M392.52 11.136v161.877",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.664303,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-23",
    d: "m391.434 10.968-.001 162.214v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.664987,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-24",
    d: "M390.346 10.8v162.55",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.665665,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-25",
    d: "m389.26 10.631-.001 162.887v0",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.666345,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-26",
    d: "M388.172 10.463v163.224",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.667029,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-27",
    d: "M387.085 10.294v163.561",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.667711,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-28",
    d: "M385.998 10.126v163.897",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.668389,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-29",
    d: "M384.911 9.958v164.234",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.669067,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-30",
    d: "M383.824 9.79v164.57",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.66975,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-31",
    d: "M382.737 9.62V174.53",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.670439,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-32",
    d: "M381.65 9.453v165.244",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.671111,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-33",
    d: "M380.563 9.284v165.581",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.671782,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-34",
    d: "M379.476 9.116v165.918",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.672463,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-35",
    d: "M378.389 8.947v166.255",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.673142,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-36",
    d: "M377.302 8.78v166.59",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.673824,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-37",
    d: "M376.215 8.61V175.54",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.674497,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-38",
    d: "M375.128 8.442v167.265",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.675162,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-39",
    d: "M374.041 8.274v167.602",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.675846,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-stack-pg-40",
    d: "M372.954 8.105v167.938",
    className: "show",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.676517,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })));
};
export { SvgNewBookSimulator as ReactComponent };
export default __webpack_public_path__ + "assets/NewBookSimulator.a085c21b05e2f45f97941a13b4638c6a.svg";